// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-24T18:45:05.810Z
// Property: The Roxanne (ID: 6767906449167726)
// Collections: 22 amenities, 20 floorplans (live), 28 photos, 75 POIs, 5 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167726",
  "property_external_id": "CgHhP6",
  "property_zillow_url": "https://www.zillow.com/apartments/atlanta-ga/hanover-midtown/CgHhP6/",
  "property_apartments_url": null,
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-roxanne",
  "property_name": "The Roxanne",
  "property_website_url": "https://demo-roxanne.multiscreensite.com/",
  "property_domain": null,
  "property_address": "1230 W Peachtree St NW",
  "property_full_address": "1230 W Peachtree St NW, Atlanta, GA 30309",
  "property_address_1": "1230 W Peachtree St NW",
  "property_address_2": null,
  "property_address_city": "Atlanta",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30309",
  "property_address_country": "US",
  "property_address_county": "Fulton County",
  "property_neighborhood_address": "Midtown Atlanta",
  "property_address_latitude": "33.7881269",
  "property_address_longitude": "-84.3881297",
  "property_email": null,
  "property_phone": "123-456-7890",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Training",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Find your fit at The Roxanne.</strong> Review current <a href=\"/floor-plans\">floor plans</a>, pricing, availability, and lease details, then <a href=\"/contact-us\">contact the leasing team</a> for the most up-to-date information.</p>",
  "property_long_description": "<p><strong>Live above Midtown’s Arts District at The Roxanne.</strong> From West Peachtree, you’re moments from Arts Center MARTA, the High Museum, Woodruff Arts Center, Colony Square dining and the everyday energy that makes Midtown Atlanta feel connected, walkable and unmistakably urban.</p><p>Inside, choose from <a href=\"/floor-plans\">studio, one-, two- and three-bedroom residences</a>, including penthouse layouts, with modern kitchens, quartz surfaces, imported cabinetry, light wood-patterned porcelain floors, walk-in closets, in-home laundry and balconies with city views. Beyond your door, <a href=\"/amenities\">resort-style amenities</a> extend the skyline experience: an elevated pool with waterfall feature, sundeck with cabana and grills, panoramic fitness center, resident lounge with demo kitchen, concierge, package receiving, bike storage, covered garage parking and Wi-Fi-equipped common areas.</p><p>When you want to head out, Piedmont Park, Atlanta Botanical Garden, Midtown restaurants and the Red and Gold lines are all close by—putting parks, culture, dining and the wider city within easy reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a03502-1964-71f5-ad0e-35bf97f0203c.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with island, open to living area with large windows and city views.",
    "public_id": "01a03502-1964-71f5-ad0e-35bf97f0203c",
    "storage_key": "property/6767906449167726/01a03502-1964-71f5-ad0e-35bf97f0203c.webp",
    "width": 1200,
    "height": 750
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "86",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "null",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-4574-734c-9dd1-50f51a46e231.webp",
  "property_primary_logo_media": {
    "alt_text": "Roxanne logo.",
    "public_id": "01a024fb-4574-734c-9dd1-50f51a46e231",
    "storage_key": "property/6767906449167726/01a024fb-4574-734c-9dd1-50f51a46e231.webp",
    "width": 933,
    "height": 232
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-7d9c-7208-8a24-505692ead2fb.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a024fb-7d9c-7208-8a24-505692ead2fb",
    "storage_key": "property/6767906449167726/01a024fb-7d9c-7208-8a24-505692ead2fb.webp",
    "width": 933,
    "height": 232
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-71dc-770d-a343-c090e4b4b2f6.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a024fb-71dc-770d-a343-c090e4b4b2f6",
    "storage_key": "property/6767906449167726/01a024fb-71dc-770d-a343-c090e4b4b2f6.webp",
    "width": 933,
    "height": 232
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a02444-fd2d-73fd-9daf-e16db0193c8a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#212222",
  "property_secondary_color": "#c1ab6e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": null,
  "property_bedrooms_min": null,
  "property_bedrooms_max": null,
  "property_bathrooms_range": null,
  "property_bathrooms_min": null,
  "property_bathrooms_max": null,
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJswyfJrsF9YgRFVkoeaWHwLI",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Roxanne",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Apartment",
  "property_home_amenities_blurb": "<p><strong>Polished Midtown amenities, made for everyday ease.</strong> At The Roxanne, recharge with Wellbeats in the fitness center, unwind by the resort-style pool with waterfall feature, or take in skyline views from the sundeck with cabanas and grilling space. Inside, imported cabinetry, quartz surfaces, glass tile, porcelain floors, walk-in closets, in-home laundry, and city-view balconies keep the experience as functional as it is refined.</p>",
  "property_home_floorplans_blurb": "<p><strong>Studio to penthouse layouts with a polished Midtown edge.</strong> At The Roxanne, open floor plans pair easy flow with modern kitchens featuring imported cabinetry, quartz countertops, and glass tile backsplashes. Select residences add private balconies with city views, while finishes like porcelain wood-look flooring, sleek lighting, walk-in closets, and in-home laundry bring everyday function into sharp focus.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview The Roxanne in sharp Midtown style.</strong> The gallery captures quartz-topped kitchens with imported cabinetry, pale porcelain floors, skyline-framing balconies, and a rooftop scene with pool, sundeck, cabanas, and grilling space. Inside the lounge, a demo kitchen, TV, and ping pong table bring the social spaces into focus—alongside polished details like subway-tiled showers, walk-in closets, and in-home laundry.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Midtown Atlanta, mapped to your day.</strong> From The Roxanne, Peachtree coffee runs, dinner at Politan Row, Rumi’s Kitchen or Saints + Council, and Arts Center MARTA are all close at hand. Head south toward Tech Square and Georgia Tech’s innovation corridor, or east to Piedmont Park and the BeltLine’s Eastside Trail. Explore skyline blocks, arts venues, food halls, transit and everyday essentials—then see how The Roxanne puts Midtown within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>What earns The Roxanne standout reviews?</strong> Residents point to exceptionally clean spaces, modern apartments, attentive service, and a calm Midtown setting that’s easy to enjoy every day. From polished common areas to the fitness space, pool, and dog-friendly amenities, the details show up again and again. Read the full reviews to hear what makes life at The Roxanne feel so well cared for.</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the map, then step into it.</strong> At The Roxanne, Midtown Atlanta feels immediate: coffee along Peachtree, dinner plans at Politan Row, Rumi’s Kitchen or Saints + Council, and last-minute rides from Arts Center MARTA without rearranging your day. Follow West Peachtree south toward Tech Square and Georgia Tech’s innovation corridor, or head east for Piedmont Park paths and the BeltLine’s Eastside Trail when you want more green in the routine. This is the Midtown rhythm—arts venues, food halls, skyline blocks, transit and everyday errands packed into a neighborhood made for wandering. Come explore it in person, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Roxanne puts you close to the places that make the map worth opening.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living with a polished Midtown Atlanta point of view.</strong> At The Roxanne, everyday convenience meets elevated downtime: start with a Wellbeats session in the fitness center, unwind beside the resort-style pool and waterfall feature, or take in skyline views from the sundeck with cabana seating and grilling space.</p><p>Inside, the details keep the experience sharp. Modern kitchens pair imported cabinetry with quartz surfaces and glass tile, while light wood-patterned porcelain floors, sleek lighting, walk-in closets, in-home laundry, and city-view balconies bring style and function into your routine. Concierge service, package receiving, covered garage parking, common-area Wi-Fi, and easy online requests help keep the day moving smoothly. Browse the <a href=\"/gallery\">photo gallery</a>, review pet-friendly details on the <a href=\"/pet-policy\">pet policy</a> page, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to apply?</strong> Start your online application for The Roxanne with confidence. Monthly rental payments will be outlined in the Resident Lease Contract, and rent, deposits, availability, and specials are subject to change without notice. Additional fees and charges may apply.</p>",
  "property_contactus_blurb": "<p><strong>Contact The Roxanne.</strong> Have questions about current rent, deposits, availability, specials, floor plans, or accessibility? Reach out to the leasing team for the latest details, lease information, or directions to 1230 W Peachtree St NW.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Roxanne?</strong> Start here for quick answers on leasing, availability, deposits, specials, fees, floor plan details, and community policies. Details may vary and are subject to the Resident Lease Contract. If you need anything clarified, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you use your space.</strong> The Roxanne’s floor plans range from efficient studios to expansive one-, two-, and three-bedroom residences, including penthouse options with extra room to stretch out. Open living areas keep the flow easy, while modern kitchens with imported cabinetry, quartz countertops, and glass tile backsplashes bring a polished Midtown Atlanta edge to everyday routines.</p><p>Choose the details that matter most to you: light wood-patterned porcelain floors, sleek lighting, stylish baths with subway-tiled showers, in-home washer and dryer, walk-in closets, and private balconies with city views in select layouts. Browse availability, compare pricing, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which Roxanne residence feels right in person.</p>",
  "property_gallery_blurb": "<p><strong>See the style before you step inside.</strong> The Roxanne photo gallery brings the building into focus: sunlit kitchens with imported cabinetry and quartz surfaces, living spaces finished with pale porcelain floors and clean-lined lighting, and balconies that frame the Midtown Atlanta skyline. Swipe from the <a href=\"/amenities\">elevated pool and sundeck</a> to cabana seating and grilling space, then linger in the lounge where a demo kitchen, TV, and ping pong table set a polished, social backdrop. You’ll also spot the everyday details that make the look work—walk-in closets, subway-tiled showers, in-home laundry, and common spaces designed with a crisp high-rise point of view. Browse the photos, compare <a href=\"/floor-plans\">studio to three-bedroom layouts</a>, then <a href=\"/schedule-a-tour\">see The Roxanne in person</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Roxanne on the map.</strong><br>View available apartments, compare layout options, and get oriented around the West Peachtree Street location. Availability, pricing, deposits, and specials may change, so use the map as a starting point for what’s currently offered.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly high-rise living, with the everyday details close at paw.</strong> At The Roxanne, your pet routine can feel as polished as your apartment: step out for fresh air, rinse off after muddy walks at the pet spa, or make quick social time easy with the community dog park. When care is on the calendar, CityVet Midtown is conveniently located at the same West Peachtree address, and Midtown Atlanta puts pocket parks, shaded sidewalks, and nearby pet services within an easy outing.</p><p>Back upstairs, in-home washers and dryers, walk-in closets, private balconies in select residences, and <a href=\"/amenities\">community spaces</a> designed for everyday convenience help life with pets stay streamlined. Review the policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how pet-friendly living fits into your day.</p>",
  "property_referafriend_blurb": "<p><strong>Share The Roxanne.</strong> Love where you live? Invite a friend to explore current availability and see which apartment home may be the right fit. Rental payments, deposits, availability, and specials are subject to change and will be outlined in the lease contract.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access</strong><br>Log in to manage your account, make rent payments as described in your Resident Lease Contract, and submit maintenance requests. Please note that fees, charges, availability, deposits, specials, and other terms may be subject to change without notice.</p>",
  "property_reviews_blurb": "<p><strong>See why The Roxanne stands out in Midtown Atlanta.</strong> Resident feedback highlights a community that feels polished, welcoming, and easy to enjoy day to day—from “exceptionally clean” spaces to modern apartments, useful amenities, and a calm atmosphere in the heart of the city.</p><p>As you read the reviews, you’ll notice repeated praise for the leasing and management team, with residents calling out helpful tours, responsive service, and staff who make the experience feel personal. You’ll also find appreciation for walkable convenience, well-maintained common areas, and thoughtful features like the fitness space, pool, and dog-friendly areas. Explore the reviews below to hear directly from those who know The Roxanne best.</p>",
  "property_created_at": "1787326781958",
  "property_scheduletour_blurb": "<p><strong>See what’s current at The Roxanne.</strong> Schedule a tour to review available floor plans, pricing, deposits, and lease details in person—then get a clearer feel for the spaces beyond representative layouts and approximate measurements.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong> The Roxanne leasing team will follow up soon with current availability, pricing, and details. Our apartment homes are designed and constructed for accessibility in accordance with applicable laws, with floor plans that may vary by home.</p>",
  "property_virtualtours_blurb": "<p><strong>Start your walkthrough before you arrive.</strong> The Roxanne’s virtual tour lets you explore a one-bedroom, one-bath apartment from anywhere, moving room to room at your own pace before you book an in-person visit.</p><p>Look for the details that shape daily life: a modern kitchen with imported cabinetry, quartz surfaces and a glass tile backsplash; light wood-patterned porcelain floors that keep the space feeling bright; sleek lighting; in-home laundry; a stylish bath; and storage designed to stay practical. As you tour, picture how the living area, bedroom and finishes connect into one polished Midtown Atlanta residence. When you’re ready, compare more <a href=\"/floor-plans\">floor plan options</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Roxanne up close.</p>",
  "property_copyright": "2026 All Rights Reserved. The Roxanne",
  "property_seo_title_home": "The Roxanne |  Apartments in Atlanta, GA",
  "property_seo_description_home": "Experience elevated living at The Roxanne in Atlanta, where modern amenities meet stylish comfort. Choose from spacious floor plans and enjoy city views today!",
  "property_seo_title_floorplans": "Floor Plans | Atlanta, GA Apartments for Rent",
  "property_seo_description_floorplans": "Uncover the ideal space at The Roxanne in Atlanta, GA! Dive into our diverse floor plans from studios to three-bedroom apartments—your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Atlanta, GA Apartments for Rent",
  "property_seo_description_amenities": "Unwind at The Roxanne in Atlanta: modern luxury, pet-friendly vibes, stunning city views, a resort-style pool, and chic amenities await.",
  "property_seo_title_gallery": "Gallery | Apartments in Atlanta, GA",
  "property_seo_description_gallery": "Capture city life at The Roxanne in Atlanta! Browse our stunning photo gallery showcasing luxury amenities, stylish interiors, and vibrant community spaces.",
  "property_seo_title_virtualtours": "Virtual Tours | The Roxanne Apartments",
  "property_seo_description_virtualtours": "Step inside The Roxanne in Atlanta, GA! Take a virtual tour of our stunning studio to three-bedroom apartments and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | The Roxanne Apartments",
  "property_seo_description_interactivemap": "Find your ideal Atlanta home at The Roxanne! Explore stylish layouts, modern amenities, and stunning city views—all with an easy-to-use interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Atlanta, GA",
  "property_seo_description_neighborhood": "Experience Atlanta at The Roxanne! Discover local gems and vibrant hotspots steps from your new studio, one, two, or three-bedroom home.",
  "property_seo_title_contact": "Contact Us | The Roxanne",
  "property_seo_description_contact": "Looking for your perfect home in Atlanta? The Roxanne offers studio to three-bedroom apartments. Have questions? Our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Atlanta, GA",
  "property_seo_description_faqs": "Find answers about The Roxanne in Atlanta! Our FAQs cover amenities and floor plans for your seamless living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Atlanta, GA",
  "property_seo_description_reviews": "Discover life at The Roxanne in Atlanta—where luxury meets comfort. Read resident reviews and find out why it's the perfect home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Atlanta, GA",
  "property_seo_description_applynow": "Experience upscale living at The Roxanne in Atlanta, featuring modern apartments, resort-style amenities, and stunning city views. Your new home awaits!",
  "property_seo_title_residentaccess": "Resident Access | The Roxanne",
  "property_seo_description_residentaccess": "Unlock convenience at The Roxanne in Atlanta! Log in to your resident portal for seamless rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | The Roxanne",
  "property_seo_description_referafriend": "Refer a friend to The Roxanne in Atlanta, GA! Great friends make great neighbors—share the joy of living in our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Roxanne",
  "property_seo_description_scheduletour": "Experience vibrant living at The Roxanne in Atlanta, GA. Schedule your tour today and find your perfect home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | The Roxanne",
  "property_seo_description_privacy": "At The Roxanne in Atlanta, your privacy matters. Learn how we safeguard your information and ensure a secure living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Roxanne",
  "property_seo_description_accessibility": "At The Roxanne in Atlanta, we prioritize accessibility for all. Join our community where everyone can thrive. Discover your next home with us!",
  "property_seo_title_sitemap": "Sitemap | The Roxanne",
  "property_seo_description_sitemap": "Navigate your way through The Roxanne in Atlanta, GA! Check out our sitemap for a seamless journey to find your perfect home and community amenities.",
  "property_seo_title_thankyou": "Thank You | The Roxanne",
  "property_seo_description_thankyou": "Thank you for connecting with The Roxanne! Our team is eager to help you find your new home in vibrant Atlanta. Stay tuned for more info soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Atlanta, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787595747695",
  "amenities": [
    {
      "id": "ec_41462e09c5b8a6eee428bb81",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b34234401bb8be7360fe5ef",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Pet‑friendly community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2bf0d4b59dee5a88b168204",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Bicycle storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0119384d9d7d2f5c84e927f5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "24‑hour emergency maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3feafdd154f29973f1653a9f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Easy online payments and maintenance requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5b700d264083c37208fac05",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Community gas grill/BBQ area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b35c1571dc943bc8b4b0b36",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Chic resident lounge with TV, ping pong table and demo kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18b4dc3dabfdebfacf2c012d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Fully‑equipped fitness center with free weights and Wellbeats",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a95f783fd217d8fd47fcd877",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Sundeck with panoramic city views outfitted with gas grill and cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_497a366832bc57f81468b13c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Elevated resort‑style pool with waterfall feature",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2fb3d8a860389a2c80b9257",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Package receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9f6e0544637928394534781",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "On‑site management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e7bf8e1ed7a8d4bf03aff49",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Covered garage parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe9ea1b255a51442d1a9e677",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "High‑speed Wi‑Fi in all common spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30f8c995e1f61208d28c4e7e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Modern kitchens with imported cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e4a21d6db2a8f9ad9f00971",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Quartz countertops and glass tile backsplash",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eed6583dfc4e4cae5e0cc495",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Elegant, light wood‑patterned porcelain floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_555c87001ba72c6040f088ef",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Sleek, modern lighting packages",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ca473ae48aa15ca3cf1b99c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Stylish bathrooms with quartz countertops and subway‑tiled showers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_548c37a75dde9a66a60529c5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and dryer in each residence",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e143c01e5d1cd60835fd94d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Private balconies with city views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc8d30c39d0c3426fc7b5cee",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_005001771dfd5db4f558e59b",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-abc7-72c9-93a7-9a4b4c8e6efc.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool at sunset with lounge chairs and a high-rise building.",
        "public_id": "01a024fb-abc7-72c9-93a7-9a4b4c8e6efc",
        "storage_key": "property/6767906449167726/01a024fb-abc7-72c9-93a7-9a4b4c8e6efc.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax by the stunning outdoor swimming pool, complete with comfortable lounge chairs and cabanas, set against a breathtaking sunset and a modern high-rise.",
      "link": "false",
      "alt_text": "Outdoor swimming pool at sunset with lounge chairs and a high-rise building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/3d07b6337b84023238459eefea774210-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_33cfb15ce54fe49357ea3875",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-a742-749e-a07f-559a8d2c755b.webp",
      "image_media": {
        "alt_text": "Luxury apartment building with a resort-style pool and lounge chairs.",
        "public_id": "01a024fb-a742-749e-a07f-559a8d2c755b",
        "storage_key": "property/6767906449167726/01a024fb-a742-749e-a07f-559a8d2c755b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy the resort-style pool area with comfortable lounge chairs, perfect for relaxing and soaking up the sun at our luxury apartment community.",
      "link": "false",
      "alt_text": "Luxury apartment building with a resort-style pool and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/6ff3dfaaee026228d4ad9ac7a3ca3597-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_39ed5027b3f9dca12a560ede",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-a8a8-76ad-ab2a-7b2a660936db.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with plush seating and a pool, overlooking city skyline at sunset.",
        "public_id": "01a024fb-a8a8-76ad-ab2a-7b2a660936db",
        "storage_key": "property/6767906449167726/01a024fb-a8a8-76ad-ab2a-7b2a660936db.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy vibrant sunsets from the rooftop lounge, complete with comfortable seating and a sparkling pool, offering breathtaking city skyline views.",
      "link": "false",
      "alt_text": "Rooftop lounge area with plush seating and a pool, overlooking city skyline at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/1e612ae0d3d3a00bcb3638a5210ab9d7-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_245d794aebf2bbdc8d95c4fe",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-a839-7169-92d1-955b31bc2fa5.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with chaise lounges, covered seating, and a barbecue grill.",
        "public_id": "01a024fb-a839-7169-92d1-955b31bc2fa5",
        "storage_key": "property/6767906449167726/01a024fb-a839-7169-92d1-955b31bc2fa5.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor lounge area, featuring comfortable chaise lounges, shaded seating, and a convenient barbecue grill for al fresco dining.",
      "link": "false",
      "alt_text": "Outdoor lounge area with chaise lounges, covered seating, and a barbecue grill.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/2c8c3266e9b40fd50ce423305cb53d20-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_5a13471c793415d869e61152",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-a780-70df-a990-e9ae8f7a0f54.webp",
      "image_media": {
        "alt_text": "Modern covered balcony lounge area with city views at sunset.",
        "public_id": "01a024fb-a780-70df-a990-e9ae8f7a0f54",
        "storage_key": "property/6767906449167726/01a024fb-a780-70df-a990-e9ae8f7a0f54.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and enjoy breathtaking city views from our stylish covered balcony lounge, perfect for socializing or unwinding at sunset.",
      "link": "false",
      "alt_text": "Modern covered balcony lounge area with city views at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/d261aee02f0e7c596d3d9bc7f602158d-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_f9d7bedda3031ff10c36d29e",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-b741-759c-97ff-fcc9f76f5969.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with fire pit and seating at dusk",
        "public_id": "01a024fb-b741-759c-97ff-fcc9f76f5969",
        "storage_key": "property/6767906449167726/01a024fb-b741-759c-97ff-fcc9f76f5969.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy the evening sky from our luxurious rooftop lounge, complete with a modern fire pit and comfortable seating.",
      "link": "false",
      "alt_text": "Rooftop lounge area with fire pit and seating at dusk",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/f2bd8fe03db4fda029c2604f98a9cb85-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_42e3a4543f5fd3392fbfea96",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-b70e-7436-a842-739c254d8983.webp",
      "image_media": {
        "alt_text": "Rooftop lounge with city skyline at sunset",
        "public_id": "01a024fb-b70e-7436-a842-739c254d8983",
        "storage_key": "property/6767906449167726/01a024fb-b70e-7436-a842-739c254d8983.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy the city views from the rooftop lounge, complete with comfortable seating and a bar area. Perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Rooftop lounge with city skyline at sunset",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/4b40e626e4cf025d5abd0cdb62b447ab-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_1fd76e51cfb04ab99ee705f2",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-b84c-72e0-8495-9e1e2e6c6b1d.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with a long bar, seating, and entertainment.",
        "public_id": "01a024fb-b84c-72e0-8495-9e1e2e6c6b1d",
        "storage_key": "property/6767906449167726/01a024fb-b84c-72e0-8495-9e1e2e6c6b1d.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Community",
      "description": "Gather in our stylish communal lounge, featuring a full-service bar, comfortable seating areas, and a large screen for entertainment. Perfect for socializing or relaxing.",
      "link": "false",
      "alt_text": "Modern communal lounge area with a long bar, seating, and entertainment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/29b218f75fa36400ba8aa5a1d458fedc-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_91fb94a5392c64ff9dbbf433",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-b90e-72ff-9239-633146340083.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with black countertop and stainless steel appliances.",
        "public_id": "01a024fb-b90e-72ff-9239-633146340083",
        "storage_key": "property/6767906449167726/01a024fb-b90e-72ff-9239-633146340083.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Sleek and modern kitchen featuring a large island with a black countertop, stainless steel appliances, and stylish pendant lighting.",
      "link": "false",
      "alt_text": "Modern kitchen island with black countertop and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/e5ec1e7a924ccf9da0e9181c117a4acc-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_87b23fc30a3755e4c590bb87",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-b9e5-73bc-93e8-d8fb520607e4.webp",
      "image_media": {
        "alt_text": "Communal table and seating area with modern booths.",
        "public_id": "01a024fb-b9e5-73bc-93e8-d8fb520607e4",
        "storage_key": "property/6767906449167726/01a024fb-b9e5-73bc-93e8-d8fb520607e4.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Community",
      "description": "A large communal live-edge wood table is surrounded by charcoal-colored chairs, with modern booth seating visible in the background. The space features contemporary art and stylish lighting.",
      "link": "false",
      "alt_text": "Communal table and seating area with modern booths.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/b8ec2d1181441b0e06aaf40a668b9aae-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_65da524b2cacb77562ab36ab",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-c46a-749c-a4f9-2b23990dcfce.webp",
      "image_media": {
        "alt_text": "Modern dining booths with elegant lighting and city views",
        "public_id": "01a024fb-c46a-749c-a4f9-2b23990dcfce",
        "storage_key": "property/6767906449167726/01a024fb-c46a-749c-a4f9-2b23990dcfce.webp",
        "width": 1536,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy a sophisticated dining experience in our community's stylish booth seating, featuring ambient lighting and panoramic city views.",
      "link": "false",
      "alt_text": "Modern dining booths with elegant lighting and city views",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/7cbae85ff93b72242cf1cc5210996c31-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_1f92f9558d93bb32fbed24fc",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-c4a5-71fd-bf31-ef537968229b.webp",
      "image_media": {
        "alt_text": "Modern theater room with plush seating and a large screen displaying a movie.",
        "public_id": "01a024fb-c4a5-71fd-bf31-ef537968229b",
        "storage_key": "property/6767906449167726/01a024fb-c4a5-71fd-bf31-ef537968229b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy movie nights in our state-of-the-art theater room, featuring comfortable seating and a large cinematic screen.",
      "link": "false",
      "alt_text": "Modern theater room with plush seating and a large screen displaying a movie.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/6a16f845be4db04d32117e1e7135af1c-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_1e64113f08e462e0e95b8f0d",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-c527-752f-b115-464f27e523c8.webp",
      "image_media": {
        "alt_text": "Modern gym with weight machines and city views at sunset.",
        "public_id": "01a024fb-c527-752f-b115-464f27e523c8",
        "storage_key": "property/6767906449167726/01a024fb-c527-752f-b115-464f27e523c8.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of weight machines and cardio equipment, with breathtaking city views.",
      "link": "false",
      "alt_text": "Modern gym with weight machines and city views at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/ed5e4993c5d1ffb2458821b2038afdc1-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_46fb719acb7aa0241a3617a4",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-c708-75a2-86e5-4458199cdd56.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with treadmills and stationary bikes.",
        "public_id": "01a024fb-c708-75a2-86e5-4458199cdd56",
        "storage_key": "property/6767906449167726/01a024fb-c708-75a2-86e5-4458199cdd56.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills, ellipticals, and stationary bikes with scenic city views.",
      "link": "false",
      "alt_text": "State-of-the-art fitness center with treadmills and stationary bikes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/bed10e02a27dc90bd6d4b09b2331f073-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_9df1c6bfe627bb9a989f1154",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-c627-751a-943d-4513f54ac48a.webp",
      "image_media": {
        "alt_text": "Dog posing in a modern dog washing station.",
        "public_id": "01a024fb-c627-751a-943d-4513f54ac48a",
        "storage_key": "property/6767906449167726/01a024fb-c627-751a-943d-4513f54ac48a.webp",
        "width": 768,
        "height": 1152
      },
      "title": "Community",
      "description": "Pamper your furry friend at our convenient on-site dog washing station, equipped with everything you need for a spa day.",
      "link": "false",
      "alt_text": "Dog posing in a modern dog washing station.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/50ea696caed48d6dd95fa3b3e966245c-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_30b9e27f6497522711de8280",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-d0e1-71ef-a9d4-a8e620adda5f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island, and city view.",
        "public_id": "01a024fb-d0e1-71ef-a9d4-a8e620adda5f",
        "storage_key": "property/6767906449167726/01a024fb-d0e1-71ef-a9d4-a8e620adda5f.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring stainless steel appliances, a large island with a sink, and ample cabinet space, opening up to a dining and living area with a city view.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, island, and city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/897a172834cfaa7acd755ff9a84bd329-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_f278d059af709c248dc27555",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-d19c-7593-93c9-e8c59bf6617c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, bar stools, stainless steel appliances, and marble backsplash.",
        "public_id": "01a024fb-d19c-7593-93c9-e8c59bf6617c",
        "storage_key": "property/6767906449167726/01a024fb-d19c-7593-93c9-e8c59bf6617c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island with bar seating, sleek cabinetry, stainless steel appliances, and elegant marble backsplash. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with island, bar stools, stainless steel appliances, and marble backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/9e09a5e65f3ec0de46d67a70b0133261-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_53f81334de045eb0bbab3900",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-d35a-7734-a813-ab0478c59f19.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and city view.",
        "public_id": "01a024fb-d35a-7734-a813-ab0478c59f19",
        "storage_key": "property/6767906449167726/01a024fb-d35a-7734-a813-ab0478c59f19.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience luxury living in this spacious apartment kitchen, featuring a large island, stainless steel appliances, and panoramic city views. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with island, stainless steel appliances, and city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/097603359744af55aca498be68bb9bee-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_88eeab20cd5c789cdb63eb99",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-d372-73ce-8b93-a6816b56afa5.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with city views",
        "public_id": "01a024fb-d372-73ce-8b93-a6816b56afa5",
        "storage_key": "property/6767906449167726/01a024fb-d372-73ce-8b93-a6816b56afa5.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious and beautifully furnished living and dining area with a modern kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern living room and kitchen with city views",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/12a3ed8c9330f034d55b26c37db7a651-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_0260f566edddc160ab28c303",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-de6f-70d7-9d50-7a07476b80f4.webp",
      "image_media": {
        "alt_text": "A built-in desk and shelving unit in a hallway, with a chair and a large window with a view.",
        "public_id": "01a024fb-de6f-70d7-9d50-7a07476b80f4",
        "storage_key": "property/6767906449167726/01a024fb-de6f-70d7-9d50-7a07476b80f4.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "This apartment features a stylish built-in desk and shelving unit, perfect for a home office or study nook. Enjoy the natural light and city views from the large window.",
      "link": "false",
      "alt_text": "A built-in desk and shelving unit in a hallway, with a chair and a large window with a view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/72c16343a053f1d91b7892dfbfdb8d15-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_1d84ff22a997010956d8099c",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-dce6-74a0-b629-649c98aada50.webp",
      "image_media": {
        "alt_text": "Modern bathroom with soaking tub, glass-enclosed shower, and double vanity.",
        "public_id": "01a024fb-dce6-74a0-b629-649c98aada50",
        "storage_key": "property/6767906449167726/01a024fb-dce6-74a0-b629-649c98aada50.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience luxury in this spacious bathroom featuring a deep soaking tub, walk-in shower, and elegant double vanity. Ample closet space included.",
      "link": "false",
      "alt_text": "Modern bathroom with soaking tub, glass-enclosed shower, and double vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/53249608d46c6df38f1d7a53b4090ee7-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_a3806f71d70b68e42e5c9bcf",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-df7f-733b-9182-cc6801be2e08.webp",
      "image_media": {
        "alt_text": "A stylish bedroom with a queen-size bed, a ceiling fan, and large windows with a view.",
        "public_id": "01a024fb-df7f-733b-9182-cc6801be2e08",
        "storage_key": "property/6767906449167726/01a024fb-df7f-733b-9182-cc6801be2e08.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen-size bed, modern ceiling fan, and expansive windows offering city views.",
      "link": "false",
      "alt_text": "A stylish bedroom with a queen-size bed, a ceiling fan, and large windows with a view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/49a798db5b6727fa62187ab3bf9066fb-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_30f8d36628e9a4ff7cbfd0e2",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-e071-740e-bafc-87e47d1cf5ce.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, shower, and walk-in closet.",
        "public_id": "01a024fb-e071-740e-bafc-87e47d1cf5ce",
        "storage_key": "property/6767906449167726/01a024fb-e071-740e-bafc-87e47d1cf5ce.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern apartment bathroom, complete with a sleek vanity, spacious shower, and convenient walk-in closet.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, toilet, shower, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/8381b0fe778e0b87499855d49c80e05c-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_c1f7e02d2d2155dbbfdc6449",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-e7d1-7515-9a15-4624297294ef.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, walk-in shower, and view of bedroom.",
        "public_id": "01a024fb-e7d1-7515-9a15-4624297294ef",
        "storage_key": "property/6767906449167726/01a024fb-e7d1-7515-9a15-4624297294ef.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience luxury in this spacious bathroom featuring a double vanity, sleek walk-in shower, and elegant finishes. A peek into the bedroom offers a glimpse of the comfortable living space.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, walk-in shower, and view of bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/1a919503b9190029a711736fac54b20b-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_eaede30c0905f4636b270a0e",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-eb21-7781-98d1-eeb3a73d51c8.webp",
      "image_media": {
        "alt_text": "Kitchen featuring Angola Black countertops, Frassino Hielo cabinets, Parnon Light backsplash, and Charcoal Oak flooring.",
        "public_id": "01a024fb-eb21-7781-98d1-eeb3a73d51c8",
        "storage_key": "property/6767906449167726/01a024fb-eb21-7781-98d1-eeb3a73d51c8.webp",
        "width": 1536,
        "height": 877
      },
      "title": "Apartment",
      "description": "Showcasing the sophisticated Angola Black countertop scheme, featuring Frassino Hielo cabinets, Parnon Light backsplash, and Charcoal Oak flooring for a modern kitchen.",
      "link": "false",
      "alt_text": "Kitchen featuring Angola Black countertops, Frassino Hielo cabinets, Parnon Light backsplash, and Charcoal Oak flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/f8b216630831ef57c575220ad6874b8d-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_667a964e930bcfd69836cb10",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-eba6-755d-8207-25477c271da0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, white quartz countertops, and stylish bar stools.",
        "public_id": "01a024fb-eba6-755d-8207-25477c271da0",
        "storage_key": "property/6767906449167726/01a024fb-eba6-755d-8207-25477c271da0.webp",
        "width": 1536,
        "height": 877
      },
      "title": "Apartment",
      "description": "Showcasing the 'Maple White' Scheme B, featuring Olmo Ambience cabinets, White Quartz Maple countertops, Bianco Mist backsplash, and Ranch Oak flooring for a sophisticated kitchen design.",
      "link": "false",
      "alt_text": "Modern kitchen with light wood cabinets, white quartz countertops, and stylish bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/928cca0ffa16024e12613a33f111a597-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_1e9f3bc3c2b94b7b5c77be34",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-ebef-714e-a817-f9ff0a066537.webp",
      "image_media": {
        "alt_text": "Kitchen featuring dark wood cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "01a024fb-ebef-714e-a817-f9ff0a066537",
        "storage_key": "property/6767906449167726/01a024fb-ebef-714e-a817-f9ff0a066537.webp",
        "width": 1536,
        "height": 877
      },
      "title": "Apartment",
      "description": "Discover the stylish finishes in this kitchen, showcasing Rovere Jolie cabinets, Maple White Quartz countertops, and white quartzite backsplash.",
      "link": "false",
      "alt_text": "Kitchen featuring dark wood cabinets, stainless steel appliances, and quartz countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/370cc73105d788b19c39aea282dd6a7d-uncropped_scaled_within_1536_1152.webp"
    },
    {
      "id": "ec_1467aff47c3865b0e93198e1",
      "source": "zillow",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fb-f43b-7032-ab3a-e2038e7c25a3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, white marble backsplash, and quartz countertops.",
        "public_id": "01a024fb-f43b-7032-ab3a-e2038e7c25a3",
        "storage_key": "property/6767906449167726/01a024fb-f43b-7032-ab3a-e2038e7c25a3.webp",
        "width": 1536,
        "height": 877
      },
      "title": "Apartment",
      "description": "Elegant kitchen featuring 'Shiitake' countertops, 'Misty Bay' backsplash, and 'Cobble Oak' flooring. The 'Samui 5' cabinets complement the stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with gray cabinets, white marble backsplash, and quartz countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://photos.zillowstatic.com/fp/8ea9254b127f9844310c90a39af40213-uncropped_scaled_within_1536_1152.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_208d3fb6cc7fc2ecdfba23a7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Foxtail Coffee - Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1230 W Peachtree St NW Unit 120, Atlanta, GA 30309, USA",
      "poi_short_description": "Coffee shop using environmentally friendly beans and offering beer, wine, and gelato, plus patio seating.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-bbaf-7635-9aa5-4b8ea13d961c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-bbaf-7635-9aa5-4b8ea13d961c",
        "storage_key": "property/6767906449167726/01a024fc-bbaf-7635-9aa5-4b8ea13d961c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.foxtailcoffee.com/locations/foxtail-coffee-midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=3540971864957639180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foxtail-coffee---midtown",
      "poi_latitude": "33.7883783",
      "poi_longitude": "-84.3879661",
      "poi_miles_from_property": "72 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 470-788-8006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-13a8-77d8-b0bb-d0ff023263da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fd-13a8-77d8-b0bb-d0ff023263da",
        "storage_key": "property/6767906449167726/01a024fd-13a8-77d8-b0bb-d0ff023263da.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJdcJm4BkF9YgRDNpzeiYPJDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_0c95976dfcaace140d56feaa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Nagomiya",
      "poi_type": "Restaurants",
      "poi_address": "1010 W Peachtree St NW Ste 400, Atlanta, GA 30309, USA",
      "poi_short_description": "Traditional Japanese small plates and sushi served in a casual setting with a Zen-inspired mural.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-bbff-7688-8f91-d3ac0f424aff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-bbff-7688-8f91-d3ac0f424aff",
        "storage_key": "property/6767906449167726/01a024fc-bbff-7688-8f91-d3ac0f424aff.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://nagomiyaatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5514137039529445597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nagomiya",
      "poi_latitude": "33.7817668",
      "poi_longitude": "-84.3882804",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-975-3851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqVmxQV0F9YgR3Qj6G2wmhkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_a019edf1edfc04ce52b84f18",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Rowdy Tiger Whiskey Bar & Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "866 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "Southern-style dishes & whiskey-based cocktails at a retro-chic joint with a rooftop terrace.",
      "poi_long_description": "Southern-style dishes & whiskey-based cocktails at a retro-chic joint with a rooftop terrace.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-b5c5-76dc-938a-c07e3505b1be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-b5c5-76dc-938a-c07e3505b1be",
        "storage_key": "property/6767906449167726/01a024fc-b5c5-76dc-938a-c07e3505b1be.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rowdytigeratlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3452630097654964447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowdy-tiger-whiskey-bar--kitchen",
      "poi_latitude": "33.7781729",
      "poi_longitude": "-84.38752389999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-412-2402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdmMaAUF9YgR3-CL78c06i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_53f489a629ec9db35dce7d6a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Atwoods Pizza Cafe",
      "poi_type": "Restaurants",
      "poi_address": "817 W Peachtree St NW Ste A105, Atlanta, GA 30308, USA",
      "poi_short_description": "Neapolitan-style pizza spot serving customizable pies & sandwiches, plus coffee & breakfast fare.",
      "poi_long_description": "Neapolitan-style pizza spot serving customizable pies & sandwiches, plus coffee & breakfast fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-bb3f-73bb-a946-4a5dd0839add.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-bb3f-73bb-a946-4a5dd0839add",
        "storage_key": "property/6767906449167726/01a024fc-bb3f-73bb-a946-4a5dd0839add.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://atwoodspizzacafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=593799295502643954&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atwoods-pizza-cafe",
      "poi_latitude": "33.7773239",
      "poi_longitude": "-84.3869831",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-748-9577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlVIoR2YE9YgR8vJPLFCZPQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_4b103d8c3c95be517e436a47",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Cypress Street Pint & Plate",
      "poi_type": "Restaurants",
      "poi_address": "817 W Peachtree St NW a180, Atlanta, GA 30308, USA",
      "poi_short_description": "A rotating lineup of beers on tap pairs with hearty American grub at a relaxed tavern with a patio.",
      "poi_long_description": "A rotating lineup of beers on tap pairs with hearty American grub at a relaxed tavern with a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-c114-7218-960e-c82ae8196301.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-c114-7218-960e-c82ae8196301",
        "storage_key": "property/6767906449167726/01a024fc-c114-7218-960e-c82ae8196301.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cypressatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5004059078031367358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-street-pint--plate",
      "poi_latitude": "33.7773253",
      "poi_longitude": "-84.38614559999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-815-9243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-13a6-774e-85b5-8134b298e03e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fd-13a6-774e-85b5-8134b298e03e",
        "storage_key": "property/6767906449167726/01a024fd-13a6-774e-85b5-8134b298e03e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJweczQWYE9YgRvtwgBTj9cUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_35d72cfddad09d5f695f225a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Ray's New York Pizza",
      "poi_type": "Restaurants",
      "poi_address": "26 5th St NW, Atlanta, GA 30332, USA",
      "poi_short_description": "Branch of chain pizzeria also offers sandwiches & pastas plus Mediterranean fare & upstairs seating.",
      "poi_long_description": "Branch of chain pizzeria also offers sandwiches & pastas plus Mediterranean fare & upstairs seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-b6ec-73d1-9d97-562c660eda3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-b6ec-73d1-9d97-562c660eda3d",
        "storage_key": "property/6767906449167726/01a024fc-b6ec-73d1-9d97-562c660eda3d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.raysnewyorkpizza.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=15318366614929564075",
      "poi_directions_map_url": "https://maps.google.com/?cid=9135719434802151797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rays-new-york-pizza",
      "poi_latitude": "33.7766683",
      "poi_longitude": "-84.3882138",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-888-9911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0OaXmYE9YgRdcEDP2yYyH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_9f790278e938c0872502d94c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "PONKO Chicken Midtown",
      "poi_type": "Restaurants",
      "poi_address": "915 W Peachtree St NW Ste 6, Atlanta, GA 30309, USA",
      "poi_short_description": "Casual chain eatery with an Asian-American menu, offering chicken tenders, tacos and plates.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-bb4b-7468-86f4-1f32b4626bca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-bb4b-7468-86f4-1f32b4626bca",
        "storage_key": "property/6767906449167726/01a024fc-bb4b-7468-86f4-1f32b4626bca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ponkochicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4808021723872782793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponko-chicken-midtown",
      "poi_latitude": "33.7800547",
      "poi_longitude": "-84.38706909999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-975-2316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKQRsaD4F9YgRyWnMq0iGuUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_7157808cf0a342aa8ee759be",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "South City Kitchen Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1144 Crescent Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Inventive takes on Southern classics, including a popular brunch, served in upscale surroundings.",
      "poi_long_description": "Inventive takes on Southern classics, including a popular brunch, served in upscale surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-b561-761f-8cd1-6158834969bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-b561-761f-8cd1-6158834969bb",
        "storage_key": "property/6767906449167726/01a024fc-b561-761f-8cd1-6158834969bb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.southcitykitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11724931360973815545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-city-kitchen-midtown",
      "poi_latitude": "33.7859545",
      "poi_longitude": "-84.3844341",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-873-7358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvQqtX0ME9YgR-X6ukvNSt6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_906fc269099a075d0f075526",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Ecco Midtown",
      "poi_type": "Restaurants",
      "poi_address": "40 7th St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Sleek spot for an ever-changing menu of seasonally inspired Continental fare & a bustling bar scene.",
      "poi_long_description": "Sleek spot for an ever-changing menu of seasonally inspired Continental fare & a bustling bar scene.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-bb43-7046-934e-0bdb4005438f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-bb43-7046-934e-0bdb4005438f",
        "storage_key": "property/6767906449167726/01a024fc-bb43-7046-934e-0bdb4005438f.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.ecco-atlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1615100838986662872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecco-midtown",
      "poi_latitude": "33.7787559",
      "poi_longitude": "-84.38584410000001",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-347-9555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlyVS2WcE9YgR2EM86Kf9aRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_caadbcb015926950c8ef6716",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "The Vortex Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "878 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Local fixture known for its burgers, beer & whiskey selection & offbeat, rock 'n' roll vibe.",
      "poi_long_description": "Local fixture known for its burgers, beer & whiskey selection & offbeat, rock 'n' roll vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-b519-7399-97f8-7a9c7866f6c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-b519-7399-97f8-7a9c7866f6c1",
        "storage_key": "property/6767906449167726/01a024fc-b519-7399-97f8-7a9c7866f6c1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.thevortexbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2105728285314260711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vortex-bar--grill",
      "poi_latitude": "33.7790602",
      "poi_longitude": "-84.3844407",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-875-1667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-icamgE9YgR5x6mB7gMOR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_aa4ddc01c28a661f6b5cea95",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Politan Row at Colony Square",
      "poi_type": "Restaurants",
      "poi_address": "1197 Peachtree St NE Apt 150, Atlanta, GA 30361, USA",
      "poi_short_description": "A casual food hall with vendors serving pizza, banh mi, ramen and tacos, plus two bars.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-cf39-779e-a2f9-775a7469ca9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-cf39-779e-a2f9-775a7469ca9f",
        "storage_key": "property/6767906449167726/01a024fc-cf39-779e-a2f9-775a7469ca9f.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://colonysquare.politanrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2160757304249077191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "politan-row-at-colony-square",
      "poi_latitude": "33.7871256",
      "poi_longitude": "-84.3821143",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-228-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJizzK5GkF9YgRx82Y7VGN_B0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_33076763bc734b26293c376d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Rumi's Kitchen Colony Square",
      "poi_type": "Restaurants",
      "poi_address": "1175 Peachtree St NE, Atlanta, GA 30361, USA",
      "poi_short_description": "Vibrant, contemporary restaurant serving creative Persian cuisine alongside cocktails & wine.",
      "poi_long_description": "Vibrant, contemporary restaurant serving creative Persian cuisine alongside cocktails & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-c5be-7598-980f-ae1df7bdf34a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-c5be-7598-980f-ae1df7bdf34a",
        "storage_key": "property/6767906449167726/01a024fc-c5be-7598-980f-ae1df7bdf34a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rumiskitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6382068897621812754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rumis-kitchen-colony-square",
      "poi_latitude": "33.7867605",
      "poi_longitude": "-84.38293329999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-777-9807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPT9qzJEF9YgREibRRtmpkVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "persian_restaurant"
    },
    {
      "id": "ec_0db83ee939c68a1ff8fb6b25",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "The Consulate Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10 10th St NW Ste P200, Atlanta, GA 30309, USA",
      "poi_short_description": "Rotating international small plates menu served in a lush, retro space with a stylish full bar.",
      "poi_long_description": "Rotating international small plates menu served in a lush, retro space with a stylish full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-ca7e-7409-a6e7-be2c1bc3251d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-ca7e-7409-a6e7-be2c1bc3251d",
        "storage_key": "property/6767906449167726/01a024fc-ca7e-7409-a6e7-be2c1bc3251d.webp",
        "width": 1280,
        "height": 781
      },
      "poi_business_url": "http://www.theconsulateatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15881603152788312066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-consulate-restaurant",
      "poi_latitude": "33.781862",
      "poi_longitude": "-84.3866219",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-254-5760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmxSlaV0E9YgRAtCrUezJZtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "ec_5e28670fbae1609764393be6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "22 14th St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-c458-755e-9afb-f7c6a1c520c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-c458-755e-9afb-f7c6a1c520c1",
        "storage_key": "property/6767906449167726/01a024fc-c458-755e-9afb-f7c6a1c520c1.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/midtownatlanta?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=347012611710925997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.7862472",
      "poi_longitude": "-84.38875569999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 470-552-4201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86c-779b-8235-2b471efdf6df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86c-779b-8235-2b471efdf6df",
        "storage_key": "property/6767906449167726/01a024fa-a86c-779b-8235-2b471efdf6df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8xL51kwF9YgRrTycvSHW0AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_a8e0fe208a06f0ac2e243acf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Publix Super Market at The Plaza Midtown",
      "poi_type": "Shopping & Retail",
      "poi_address": "950 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-cc05-710f-86f2-07fe4da62ad4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-cc05-710f-86f2-07fe4da62ad4",
        "storage_key": "property/6767906449167726/01a024fc-cc05-710f-86f2-07fe4da62ad4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1061&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=3963935707884851565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-the-plaza-midtown",
      "poi_latitude": "33.7804802",
      "poi_longitude": "-84.388809",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-253-3544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86c-779b-8235-2b471efdf6df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86c-779b-8235-2b471efdf6df",
        "storage_key": "property/6767906449167726/01a024fa-a86c-779b-8235-2b471efdf6df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfTK9iWcE9YgRbZH2RIa6Ajc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_13bf18a822dae244cefe9d99",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Midtown Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "225 10th St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Market stocking a selection of beers as well as wine and other snacks for purchase.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-cbad-705f-905c-3b3c024aed54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-cbad-705f-905c-3b3c024aed54",
        "storage_key": "property/6767906449167726/01a024fc-cbad-705f-905c-3b3c024aed54.webp",
        "width": 1280,
        "height": 1195
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17583212864112900016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-market",
      "poi_latitude": "33.7816772",
      "poi_longitude": "-84.3802123",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-685-8372",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-13a6-774e-85b5-85a9ad998881.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fd-13a6-774e-85b5-85a9ad998881",
        "storage_key": "property/6767906449167726/01a024fd-13a6-774e-85b5-85a9ad998881.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ6-VH80EE9YgRsDeHp_AeBPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_5bf5a3a951530fe4eb1f1ec2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "842 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-c621-77ae-91e6-16a1baba5ccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-c621-77ae-91e6-16a1baba5ccc",
        "storage_key": "property/6767906449167726/01a024fc-c621-77ae-91e6-16a1baba5ccc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/atlanta-ga-pharmacies/842-peachtree-street-ne-atlanta-ga-30308/storeid=2943?WT.mc_id=LS_GOOGLE_FS_2943",
      "poi_directions_map_url": "https://maps.google.com/?cid=15933037119015621559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "33.7774986",
      "poi_longitude": "-84.3845652",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-892-8468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwRLxGIF9YgRtxMKyNeEHd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_c106438daa88edd29cecf2f6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Blick Art Materials",
      "poi_type": "Shopping & Retail",
      "poi_address": "878 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Retailer stocking a large assortment of art supplies, including paint, clay & canvases.",
      "poi_long_description": "Retailer stocking a large assortment of art supplies, including paint, clay & canvases.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-ce65-7779-a06c-6a575d1f50e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-ce65-7779-a06c-6a575d1f50e8",
        "storage_key": "property/6767906449167726/01a024fc-ce65-7779-a06c-6a575d1f50e8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dickblick.com/stores/georgia/atlanta/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2192778916929763005&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blick-art-materials",
      "poi_latitude": "33.7787492",
      "poi_longitude": "-84.384503",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-347-9119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a857-7330-a390-9cb602b7e6b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a857-7330-a390-9cb602b7e6b0",
        "storage_key": "property/6767906449167726/01a024fa-a857-7330-a390-9cb602b7e6b0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6bk1aGgE9YgRvXaQns5Qbh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_059e585943196c922a854e78",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "595 Piedmont Ave NE Ste 100, Atlanta, GA 30308, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-caf5-73d4-a080-44f26c8c95a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-caf5-73d4-a080-44f26c8c95a6",
        "storage_key": "property/6767906449167726/01a024fc-caf5-73d4-a080-44f26c8c95a6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-595+piedmont+ave+ne-atlanta-ga-30308/id=6032",
      "poi_directions_map_url": "https://maps.google.com/?cid=10791041622720626702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "33.770849",
      "poi_longitude": "-84.381102",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-685-9665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-13a8-77d8-b0bb-cc3b69f22cf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fd-13a8-77d8-b0bb-cc3b69f22cf0",
        "storage_key": "property/6767906449167726/01a024fd-13a8-77d8-b0bb-cc3b69f22cf0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRGnEm4E9YgRDsC3ti57wZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_c1e621c870051aa2669580cd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Ponce Mini Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "75 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Modern convenience store offering wine, craft beer, CBD products, and snacks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-d1e2-707f-8739-737111233f38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-d1e2-707f-8739-737111233f38",
        "storage_key": "property/6767906449167726/01a024fc-d1e2-707f-8739-737111233f38.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://ponceminimarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6297312565983132688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponce-mini-market",
      "poi_latitude": "33.7720098",
      "poi_longitude": "-84.3846212",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-228-5806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-13a6-774e-85b5-85a9ad998881.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fd-13a6-774e-85b5-85a9ad998881",
        "storage_key": "property/6767906449167726/01a024fd-13a6-774e-85b5-85a9ad998881.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJNVD8u9QF9YgREDwHB2qMZFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_8c36989b27791bb5a17eaa35",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Ponce City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "675 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Vibrant converted historic Sears building, now a market with a food hall, shops & living space.",
      "poi_long_description": "Vibrant converted historic Sears building, now a market with a food hall, shops & living space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-6bd4-730e-8ffa-8b3bf10d12ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fa-6bd4-730e-8ffa-8b3bf10d12ca",
        "storage_key": "property/6767906449167726/01a024fa-6bd4-730e-8ffa-8b3bf10d12ca.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://poncecitymarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14460613837555701121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponce-city-market",
      "poi_latitude": "33.7727683",
      "poi_longitude": "-84.3655967",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-900-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a857-7330-a390-9cb602b7e6b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a857-7330-a390-9cb602b7e6b0",
        "storage_key": "property/6767906449167726/01a024fa-a857-7330-a390-9cb602b7e6b0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTTv9ohAE9YgRgRWbbatrrsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_3db0b065d6765669bf3856f9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Barnes & Noble at Georgia Tech",
      "poi_type": "Shopping & Retail",
      "poi_address": "48 5th St NW, Atlanta, GA 30332, USA",
      "poi_short_description": "Bookseller chain with a broad selection of titles for adults & kids, plus magazines & gifts.",
      "poi_long_description": "Bookseller chain with a broad selection of titles for adults & kids, plus magazines & gifts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-d386-7008-b64b-5dec948bf3b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-d386-7008-b64b-5dec948bf3b9",
        "storage_key": "property/6767906449167726/01a024fc-d386-7008-b64b-5dec948bf3b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.shopgatech.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4240433321532051399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barnes--noble-at-georgia-tech",
      "poi_latitude": "33.7766667",
      "poi_longitude": "-84.38861109999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-894-2515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a857-7330-a390-9cb602b7e6b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a857-7330-a390-9cb602b7e6b0",
        "storage_key": "property/6767906449167726/01a024fa-a857-7330-a390-9cb602b7e6b0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyc9l82YE9YgRx8-ln6ML2To",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "ec_851d8b0b2ac13299eb69632e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "The UPS Store",
      "poi_type": "Major Employers & Offices",
      "poi_address": "925B Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_long_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-d3d0-75a7-b789-85965cf6d8dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-d3d0-75a7-b789-85965cf6d8dd",
        "storage_key": "property/6767906449167726/01a024fc-d3d0-75a7-b789-85965cf6d8dd.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://locations.theupsstore.com/ga/atlanta/925b-peachtree-st-ne?utm_source=Yext&utm_medium=organic&utm_campaign=Listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=8774051155252946755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ups-store",
      "poi_latitude": "33.7799409",
      "poi_longitude": "-84.383922",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-685-8280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT87kJGgE9YgRQyf17Qmxw3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shipping_service"
    },
    {
      "id": "ec_14482fbfdc4cc5a74db4af55",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Midtown High School",
      "poi_type": "Education",
      "poi_address": "929 Charles Allen Dr NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-d4b6-759c-ae0f-4fb46329e86a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-d4b6-759c-ae0f-4fb46329e86a",
        "storage_key": "property/6767906449167726/01a024fc-d4b6-759c-ae0f-4fb46329e86a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantapublicschools.us/midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=18124944716900365978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-high-school",
      "poi_latitude": "33.7805714",
      "poi_longitude": "-84.3722454",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-802-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcTOFGj4E9YgRmnZwoDC9iPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_a383cb226e3d00ad243f3846",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Savannah College of Art and Design (SCAD), Atlanta",
      "poi_type": "Education",
      "poi_address": "1600 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-766e-765f-82bd-50181cc13ccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fa-766e-765f-82bd-50181cc13ccc",
        "storage_key": "property/6767906449167726/01a024fa-766e-765f-82bd-50181cc13ccc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.scad.edu/atlanta/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9085416020321215593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-college-of-art-and-design-scad-atlanta",
      "poi_latitude": "33.7971506",
      "poi_longitude": "-84.3907208",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-253-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIfRPTVEE9YgRaaTj37vhFX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_c0e462d7d18acdcd4c8239fc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Georgia Institute of Technology-Dean's Office",
      "poi_type": "Education",
      "poi_address": "225 North Ave NW #202, Atlanta, GA 30332, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-d6fc-70fb-8e0d-5dddadea84c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-d6fc-70fb-8e0d-5dddadea84c0",
        "storage_key": "property/6767906449167726/01a024fc-d6fc-70fb-8e0d-5dddadea84c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatech.edu/about/leadership",
      "poi_directions_map_url": "https://maps.google.com/?cid=2281686728971383656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-institute-of-technology-deans-office",
      "poi_latitude": "33.7724231",
      "poi_longitude": "-84.3947865",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-894-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfwlvi2IE9YgRaPMPuf0tqh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "ec_fa7b9a3c025a757adc72f6a2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "The Goddard School of Atlanta - Midtown",
      "poi_type": "Education",
      "poi_address": "1080 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Playful chain school welcoming kids into colorful classrooms for learning and socialization.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-d63e-767f-9f8d-7f57f35ec1b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-d63e-767f-9f8d-7f57f35ec1b2",
        "storage_key": "property/6767906449167726/01a024fc-d63e-767f-9f8d-7f57f35ec1b2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/ga/atlanta/atlanta-midtown?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=9643405445568511386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-atlanta---midtown",
      "poi_latitude": "33.7841552",
      "poi_longitude": "-84.3895711",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-541-1936",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa_eISFwE9YgRmr0t6ChC1IU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_277e8685ed6d2994f6caccc1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Bright Horizons at Atlantic Station",
      "poi_type": "Education",
      "poi_address": "1381 Market St NW, Atlanta, GA 30363, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-d8e5-778f-bd6a-5d341f28c21d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-d8e5-778f-bd6a-5d341f28c21d",
        "storage_key": "property/6767906449167726/01a024fc-d8e5-778f-bd6a-5d341f28c21d.webp",
        "width": 1152,
        "height": 768
      },
      "poi_business_url": "https://www.brighthorizons.com/daycare-centers/ga/atlanta/1381-market-street-30363?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=1362925812386251125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons-at-atlantic-station",
      "poi_latitude": "33.7923205",
      "poi_longitude": "-84.3945336",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-618-1709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTxhbjlcE9YgRdUF-Js4V6hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_073a8be80936bd86d770dcd7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Primrose School of Midtown at Colony Square",
      "poi_type": "Education",
      "poi_address": "1197 Peachtree St NE Apt 554, Atlanta, GA 30361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-d954-7249-8c57-f7441a30351a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-d954-7249-8c57-f7441a30351a",
        "storage_key": "property/6767906449167726/01a024fc-d954-7249-8c57-f7441a30351a.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/midtown-colony-square/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=10215777039959737651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-midtown-at-colony-square",
      "poi_latitude": "33.7877156",
      "poi_longitude": "-84.3820715",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-745-9797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7aGRZEQE9YgRM0Vkoxe7xY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_46a32c14063cc6ad8ea33c0e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "The Children's Campus at Georgia Tech",
      "poi_type": "Education",
      "poi_address": "251 10th St NW Bldg F, Atlanta, GA 30318, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-e4a2-71de-8f1b-9063f8f8ff12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-e4a2-71de-8f1b-9063f8f8ff12",
        "storage_key": "property/6767906449167726/01a024fc-e4a2-71de-8f1b-9063f8f8ff12.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.brighthorizons.com/daycare-centers/ga/atlanta/251-10th-street-30318?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=12436080787134707189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-childrens-campus-at-georgia-tech",
      "poi_latitude": "33.78257",
      "poi_longitude": "-84.39578929999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 470-437-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9UmqjF8E9YgR9XU5M5bVlaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_5f8e27522a15708b1be2d58c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Cristo Rey Atlanta Jesuit High School",
      "poi_type": "Education",
      "poi_address": "222 Piedmont Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-d941-76ee-b80d-91c6a8e9c6d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-d941-76ee-b80d-91c6a8e9c6d4",
        "storage_key": "property/6767906449167726/01a024fc-d941-76ee-b80d-91c6a8e9c6d4.webp",
        "width": 831,
        "height": 831
      },
      "poi_business_url": "http://www.cristoreyatlanta.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=600221286083500610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cristo-rey-atlanta-jesuit-high-school",
      "poi_latitude": "33.7607273",
      "poi_longitude": "-84.3825622",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-637-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9UP8umUE9YgRQpqiXxRqVAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_6efc02cb60c10dcfd8f0cc54",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Dar-Un-Noor Academy",
      "poi_type": "Education",
      "poi_address": "434 14th St NW, Atlanta, GA 30318, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-dc32-747b-9108-39801333f94b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-dc32-747b-9108-39801333f94b",
        "storage_key": "property/6767906449167726/01a024fc-dc32-747b-9108-39801333f94b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.darunnoor.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17647756409139953827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dar-un-noor-academy",
      "poi_latitude": "33.7855612",
      "poi_longitude": "-84.4010402",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-876-5051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnVCaCPQE9YgRowBpyfNs6fQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_9247ac059b5d2baf9fa7176b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Atlanta Speech School",
      "poi_type": "Education",
      "poi_address": "3160 Northside Pkwy NW, Atlanta, GA 30327, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-daf0-7135-a41e-11d03f297949.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-daf0-7135-a41e-11d03f297949",
        "storage_key": "property/6767906449167726/01a024fc-daf0-7135-a41e-11d03f297949.webp",
        "width": 640,
        "height": 427
      },
      "poi_business_url": "http://www.atlantaspeechschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963595263744232869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-speech-school",
      "poi_latitude": "33.841681",
      "poi_longitude": "-84.4226733",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-233-5332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi6wxLFoF9YgRpU2ByTDOICk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_57d491e4712e083a23d8de85",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Center For Puppetry Arts",
      "poi_type": "Entertainment",
      "poi_address": "1404 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Long-standing puppetry museum with a variety of exhibits, performances, workshops & classes.",
      "poi_long_description": "Long-standing puppetry museum with a variety of exhibits, performances, workshops & classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-dcad-709f-a026-d2f91701882a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-dcad-709f-a026-d2f91701882a",
        "storage_key": "property/6767906449167726/01a024fc-dcad-709f-a026-d2f91701882a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.puppet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8253606720874116330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-for-puppetry-arts",
      "poi_latitude": "33.792875",
      "poi_longitude": "-84.38985989999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-873-3391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f898f786dac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f898f786dac2",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f898f786dac2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fRXllAE9YgR6nR6SZWzinI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_6fcfea285a09424657ebeb2e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "High Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1280 Peachtree Rd NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Museum known for its diverse art collection & modern architecture by Richard Meier & Renzo Piano.",
      "poi_long_description": "Museum known for its diverse art collection & modern architecture by Richard Meier & Renzo Piano.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-de11-7268-a0ee-2e14300e9e35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-de11-7268-a0ee-2e14300e9e35",
        "storage_key": "property/6767906449167726/01a024fc-de11-7268-a0ee-2e14300e9e35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.high.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17827694190187609074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "high-museum-of-art",
      "poi_latitude": "33.7900632",
      "poi_longitude": "-84.38555199999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-733-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f898f786dac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f898f786dac2",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f898f786dac2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bUMEUE9YgR8nttKmmxaPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_002f4f7706e2b7219d719545",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Alliance Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1280 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Acclaimed theater company featuring house productions of major plays & acting workshops.",
      "poi_long_description": "Acclaimed theater company featuring house productions of major plays & acting workshops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-e975-77b7-b058-5f6ff8c08b83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-e975-77b7-b058-5f6ff8c08b83",
        "storage_key": "property/6767906449167726/01a024fc-e975-77b7-b058-5f6ff8c08b83.webp",
        "width": 1280,
        "height": 1040
      },
      "poi_business_url": "http://alliancetheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15996732928718111168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alliance-theatre",
      "poi_latitude": "33.7892466",
      "poi_longitude": "-84.38540859999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 404-733-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bUMEUE9YgRwIEJJ9jP_90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_f99ca2c46095c7d892e4ebe3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Fox Theatre",
      "poi_type": "Entertainment",
      "poi_address": "660 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Restored opulent theater built in 1920s with 3,600-pipe organ hosts ballet, movies & other events.",
      "poi_long_description": "Restored opulent theater built in 1920s with 3,600-pipe organ hosts ballet, movies & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-e2ad-72e2-ae9b-df1e047389e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-e2ad-72e2-ae9b-df1e047389e5",
        "storage_key": "property/6767906449167726/01a024fc-e2ad-72e2-ae9b-df1e047389e5.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "https://www.foxtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1917821642260137630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-theatre",
      "poi_latitude": "33.7726136",
      "poi_longitude": "-84.3853395",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 855-285-8499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28DQdm8E9YgRnsZ4YZ94nRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_ba35f1bbeb971c30ebad2e88",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Center Stage Theater",
      "poi_type": "Entertainment",
      "poi_address": "1374 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Intimate performing arts venue seats 1,050 with premier lighting & sound & separate lounge space.",
      "poi_long_description": "Intimate performing arts venue seats 1,050 with premier lighting & sound & separate lounge space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-de67-733b-a435-b8c41b81c36b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-de67-733b-a435-b8c41b81c36b",
        "storage_key": "property/6767906449167726/01a024fc-de67-733b-a435-b8c41b81c36b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.centerstage-atlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16982912977202433654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-stage-theater",
      "poi_latitude": "33.7922155",
      "poi_longitude": "-84.3879559",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 404-885-1365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXLceFAE9YgRds6FmV9tr-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_144647b5ba083ba9a1eb7dd5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Atlanta Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1345 Piedmont Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_long_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-8bf5-706f-81fa-70ad8a6b29e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fa-8bf5-706f-81fa-70ad8a6b29e1",
        "storage_key": "property/6767906449167726/01a024fa-8bf5-706f-81fa-70ad8a6b29e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11595354526965683893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-botanical-garden",
      "poi_latitude": "33.7899568",
      "poi_longitude": "-84.37259879999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-876-5859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RXVJTgE9YgRtdaB6IH56qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_f6fa8460cdb750ed14e7e7e8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Piedmont Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_long_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-8be1-7373-a1b3-9c8523053d7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fa-8be1-7373-a1b3-9c8523053d7a",
        "storage_key": "property/6767906449167726/01a024fa-8be1-7373-a1b3-9c8523053d7a.webp",
        "width": 736,
        "height": 485
      },
      "poi_business_url": "https://piedmontpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17559229622006002958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-park",
      "poi_latitude": "33.7879265",
      "poi_longitude": "-84.37216819999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a861-763b-a638-a61cd88c17e4",
        "storage_key": "property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaxkUDkE9YgRDjUv9U7qrvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_938add62ee94cc58276c0fd1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Plaza Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1049 Ponce De Leon Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Independent movie theater showcases cult classics & midnight movies on Friday on the silver screen.",
      "poi_long_description": "Independent movie theater showcases cult classics & midnight movies on Friday on the silver screen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-e3e5-763c-afe8-e4c95f994cfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-e3e5-763c-afe8-e4c95f994cfb",
        "storage_key": "property/6767906449167726/01a024fc-e3e5-763c-afe8-e4c95f994cfb.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.plazaatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5819026170921268730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaza-theatre",
      "poi_latitude": "33.7734567",
      "poi_longitude": "-84.3530406",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 470-410-1939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-13b8-748d-878a-4df8aec5e2de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fd-13b8-748d-878a-4df8aec5e2de",
        "storage_key": "property/6767906449167726/01a024fd-13b8-748d-878a-4df8aec5e2de.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJP47X-6MG9YgR-rV20HhVwVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_10e5b46ea087220037bbcea0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Variety Playhouse",
      "poi_type": "Entertainment",
      "poi_address": "1099 Euclid Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Converted movie theater now serves as an intimate concert hall featuring a variety of popular acts.",
      "poi_long_description": "Converted movie theater now serves as an intimate concert hall featuring a variety of popular acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-e451-7465-9756-a922e2b4097a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-e451-7465-9756-a922e2b4097a",
        "storage_key": "property/6767906449167726/01a024fc-e451-7465-9756-a922e2b4097a.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.variety-playhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14554971689164868841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "variety-playhouse",
      "poi_latitude": "33.76372870000001",
      "poi_longitude": "-84.35107149999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 404-524-7354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8d2cqkG9YgR6QyKwKKl_ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_a7f77bd10922c6ecd7863a59",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Piedmont Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "1968 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-e891-7619-96dc-183ea2dcb03e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-e891-7619-96dc-183ea2dcb03e",
        "storage_key": "property/6767906449167726/01a024fc-e891-7619-96dc-183ea2dcb03e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-atlanta?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY4MzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10361705813315035831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-atlanta",
      "poi_latitude": "33.8088868",
      "poi_longitude": "-84.394939",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-605-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a8ca-7367-8ecb-a3dbb3653e2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a8ca-7367-8ecb-a3dbb3653e2e",
        "storage_key": "property/6767906449167726/01a024fa-a8ca-7367-8ecb-a3dbb3653e2e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ2L4-KkF9YgRtyK-3YkszI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_9113aa0b8d8c4a81e45842a4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Emory University Hospital Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "550 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-8d0b-76f3-b535-211379873831.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fa-8d0b-76f3-b535-211379873831",
        "storage_key": "property/6767906449167726/01a024fa-8d0b-76f3-b535-211379873831.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/hospitals/emory-university-hospital-midtown?&utm_campaign=brand_euh_ra_gmb-locations&utm_source=google&utm_medium=gmb&utm_content=gmb_locations?&utm_campaign=brand_all_non&utm_source=google&utm_medium=gmb&utm_content=gmb-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=15043808532116501154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university-hospital-midtown",
      "poi_latitude": "33.7686442",
      "poi_longitude": "-84.38619290000001",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-686-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a8ca-7367-8ecb-a3dbb3653e2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a8ca-7367-8ecb-a3dbb3653e2e",
        "storage_key": "property/6767906449167726/01a024fa-a8ca-7367-8ecb-a3dbb3653e2e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42AWonoE9YgRonLLiSdYxtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_11cc021c82fbc80e3aacd4db",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Piedmont QuickCare - Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "595 Piedmont Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-ea2d-726a-a511-876da09884ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-ea2d-726a-a511-876da09884ba",
        "storage_key": "property/6767906449167726/01a024fc-ea2d-726a-a511-876da09884ba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.care.piedmont.org/locations/location-details/practice/1985?utm_source=directorylisting&utm_medium=seo&utm_campaign=10221&y_source=1_MjA2MTQ5NDI2OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15354154154259137251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-quickcare---midtown",
      "poi_latitude": "33.7708702",
      "poi_longitude": "-84.3811193",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-732-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAdFaHiwF9YgR40I0f9rpFNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_4f31b5118f52a0bac3fc6f03",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "595 Piedmont Ave NE Ste 100, Atlanta, GA 30308, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-eb5d-76fe-92fe-4e94de813466.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-eb5d-76fe-92fe-4e94de813466",
        "storage_key": "property/6767906449167726/01a024fc-eb5d-76fe-92fe-4e94de813466.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-595+piedmont+ave+ne-atlanta-ga-30308/id=6032",
      "poi_directions_map_url": "https://maps.google.com/?cid=13312630410249885726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.7707331",
      "poi_longitude": "-84.3812556",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-685-9665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd7Nc4G0E9YgRHtgBJdP2v7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_8aa336bc382cf53819748cb7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "933 Peachtree St NE #939A, Atlanta, GA 30309, USA",
      "poi_short_description": "Group, treadmill-based workout studio, featuring certified instructors and fitness training in an energetic environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-f561-7246-aba2-1ab9be46173b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-f561-7246-aba2-1ab9be46173b",
        "storage_key": "property/6767906449167726/01a024fc-f561-7246-aba2-1ab9be46173b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/atlanta-georgia-0137?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=621678546688391647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "33.780276",
      "poi_longitude": "-84.3839747",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-747-7107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWpDnUIE9YgR37nXK1iloAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4d2b92cdbb349e5c0feeb17b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "CorePower Yoga - Atlanta Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "860 Peachtree St NE Suite J, Atlanta, GA 30308, USA",
      "poi_short_description": "Branch of a fitness chain offering vigorous yoga classes with a focus on mindfulness.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-ed92-735b-a0a3-648efa6e2a2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-ed92-735b-a0a3-648efa6e2a2b",
        "storage_key": "property/6767906449167726/01a024fc-ed92-735b-a0a3-648efa6e2a2b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/ga/atlanta/atlanta-midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=3395339368669349519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---atlanta-midtown",
      "poi_latitude": "33.7784663",
      "poi_longitude": "-84.38542319999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZUNWe2gE9YgRj4ZvoSqrHi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_6e98498c6ffb8495d7aba0fb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "CrossFit Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "1210 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Crossfit gym, plus yoga classes, all focusing on community.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-ee15-770e-829a-87a7a7bc7a79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-ee15-770e-829a-87a7a7bc7a79",
        "storage_key": "property/6767906449167726/01a024fc-ee15-770e-829a-87a7a7bc7a79.webp",
        "width": 1280,
        "height": 572
      },
      "poi_business_url": "https://www.crossfitmidtown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9634256797955084902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-midtown",
      "poi_latitude": "33.7877804",
      "poi_longitude": "-84.3895361",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 678-223-3308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRuXjlwE9YgRZlIBZYPBs4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f12e6d8e6ce384770db1a3f7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "[solidcore] Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "33 Peachtree Pl NE #3, Atlanta, GA 30309, USA",
      "poi_short_description": "High-intensity, low-impact, strength-based workout on a custom-built Pilates reformer machine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-ee62-7194-a825-d14c84a035ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-ee62-7194-a825-d14c84a035ec",
        "storage_key": "property/6767906449167726/01a024fc-ee62-7194-a825-d14c84a035ec.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://solidcore.co/studios/midtown?siteId=559144&locationId=1&utm_source=google&utm_medium=search&utm_content=local-listing&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=170830767903207345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "solidcore-midtown",
      "poi_latitude": "33.7803213",
      "poi_longitude": "-84.3870475",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-800-9840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHzzxV10E9YgRse-Tpa3pXgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f3d4de74e024c1d797acf2ef",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "exhale Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "1065 Peachtree St NE NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Sleek fitness club in the Loews Atlanta Hotel with yoga, barre & spin classes, plus spa treatments.",
      "poi_long_description": "Sleek fitness club in the Loews Atlanta Hotel with yoga, barre & spin classes, plus spa treatments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-f57c-7195-a751-8b0c43204a6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-f57c-7195-a751-8b0c43204a6a",
        "storage_key": "property/6767906449167726/01a024fc-f57c-7195-a751-8b0c43204a6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://exhalespa.com/midtown-atlanta/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5805241949785324747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exhale-spa",
      "poi_latitude": "33.7835524",
      "poi_longitude": "-84.3833196",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-720-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_dJAkME9YgRy3wmvMtckFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spa"
    },
    {
      "id": "ec_9dc5798ed5649be5e4783f7f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Piedmont Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Park Dr NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Fenced off-leash dog park on 3 acres, with small- & large-breed areas, shade, water & benches.",
      "poi_long_description": "Fenced off-leash dog park on 3 acres, with small- & large-breed areas, shade, water & benches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-f070-72f8-8407-c56e80fa7aed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-f070-72f8-8407-c56e80fa7aed",
        "storage_key": "property/6767906449167726/01a024fc-f070-72f8-8407-c56e80fa7aed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.piedmontpark.org/things-to-do/dog-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16865513577315875636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-dog-park",
      "poi_latitude": "33.7879898",
      "poi_longitude": "-84.37115949999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a861-763b-a638-a61cd88c17e4",
        "storage_key": "property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-bEWbTkE9YgRNLtwwj1XDuo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_421618f4733c71aff54a6382",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Colony Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "1197 Peachtree St NE, Atlanta, GA 30361, USA",
      "poi_short_description": "Mixed-use complex featuring professional offices, shops, services, restaurants & frequent events.",
      "poi_long_description": "Mixed-use complex featuring professional offices, shops, services, restaurants & frequent events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-f447-77a2-bd2c-e97c4f51e062.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-f447-77a2-bd2c-e97c4f51e062",
        "storage_key": "property/6767906449167726/01a024fc-f447-77a2-bd2c-e97c4f51e062.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colonysquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2240213496914822969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colony-square",
      "poi_latitude": "33.7873463",
      "poi_longitude": "-84.38246629999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-965-9091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a857-7330-a390-9cb602b7e6b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a857-7330-a390-9cb602b7e6b0",
        "storage_key": "property/6767906449167726/01a024fa-a857-7330-a390-9cb602b7e6b0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgbZHQ0QE9YgROcekaE7WFh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_4b3066938dde2938f36392fa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "10th Street Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1021 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-f68e-73c8-b4f5-5761f87c752a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-f68e-73c8-b4f5-5761f87c752a",
        "storage_key": "property/6767906449167726/01a024fc-f68e-73c8-b4f5-5761f87c752a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15083564355257776895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "10th-street-dog-park",
      "poi_latitude": "33.7824109",
      "poi_longitude": "-84.38378759999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a861-763b-a638-a61cd88c17e4",
        "storage_key": "property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZ8z8egF9YgR_zribd2VU9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_11caa3b7d11c63745d5dab0b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Pershing Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1720 Peachtree St NE Unit 333, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-fa93-7506-98a2-764247fcd275.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-fa93-7506-98a2-764247fcd275",
        "storage_key": "property/6767906449167726/01a024fc-fa93-7506-98a2-764247fcd275.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.atlantaga.gov/government/departments/department-parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=15821385347496745285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pershing-point-park",
      "poi_latitude": "33.7939667",
      "poi_longitude": "-84.387545",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a861-763b-a638-a61cd88c17e4",
        "storage_key": "property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5m9BFAE9YgRRRkd9CXakNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_19c7eb58ed66cda0dd3b5b43",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Piedmont Park And Eastside BeltLine Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Meadow Path, Atlanta, GA 30306, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-fb49-77ed-a53c-657b90c50dbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-fb49-77ed-a53c-657b90c50dbf",
        "storage_key": "property/6767906449167726/01a024fc-fb49-77ed-a53c-657b90c50dbf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6468205440877830069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-park-and-eastside-beltline-trail",
      "poi_latitude": "33.7822963",
      "poi_longitude": "-84.36873899999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a861-763b-a638-a61cd88c17e4",
        "storage_key": "property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9Nk1j0E9YgRtZ_FFZSuw1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_69d2d37abd8134221f069f50",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Historic Fourth Ward Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "680 Dallas St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_long_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-f8eb-77a9-95b0-13f9b932b056.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-f8eb-77a9-95b0-13f9b932b056",
        "storage_key": "property/6767906449167726/01a024fc-f8eb-77a9-95b0-13f9b932b056.webp",
        "width": 1280,
        "height": 667
      },
      "poi_business_url": "http://www.h4wpc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1819443021458306877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-fourth-ward-park",
      "poi_latitude": "33.7694043",
      "poi_longitude": "-84.3647968",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-546-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a861-763b-a638-a61cd88c17e4",
        "storage_key": "property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSnz-A8E9YgRPfcVx8n1Pxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_ad3d87265b296961b3755ef3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Woodruff Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "91 Peachtree St, Atlanta, GA 30303, USA",
      "poi_short_description": "City park with 2 fountains, playgrounds, sculptures, chess court & pavilion, plus events.",
      "poi_long_description": "City park with 2 fountains, playgrounds, sculptures, chess court & pavilion, plus events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-fa1e-7103-b7b3-09fa70560fa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-fa1e-7103-b7b3-09fa70560fa0",
        "storage_key": "property/6767906449167726/01a024fc-fa1e-7103-b7b3-09fa70560fa0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantaga.gov/government/departments/department-parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=10797897627385162082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodruff-park",
      "poi_latitude": "33.755217",
      "poi_longitude": "-84.388628",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-546-6744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a861-763b-a638-a61cd88c17e4",
        "storage_key": "property/6767906449167726/01a024fa-a861-763b-a638-a61cd88c17e4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXwkh_4YD9YgRYmlTsa7W2ZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_2abafa611c28f7fefcc9f592",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Arts Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-96bf-76ea-b82d-8cc7b07d6911.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fa-96bf-76ea-b82d-8cc7b07d6911",
        "storage_key": "property/6767906449167726/01a024fa-96bf-76ea-b82d-8cc7b07d6911.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.itsmarta.com/Arts-Center.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6693853067366476356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arts-center",
      "poi_latitude": "33.78918",
      "poi_longitude": "-84.38727999999999",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-ab99-77b2-a0d6-8cedadbd82fc",
        "storage_key": "property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6XSS4FoE9YgRRKoJM-ZX5Vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_89029ce302e66e950efa1140",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Midtown",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-9e9c-73dd-add5-2fd135aac400.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fa-9e9c-73dd-add5-2fd135aac400",
        "storage_key": "property/6767906449167726/01a024fa-9e9c-73dd-add5-2fd135aac400.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Midtown.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3874113686536918320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown",
      "poi_latitude": "33.78107",
      "poi_longitude": "-84.38632",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-ab99-77b2-a0d6-8cedadbd82fc",
        "storage_key": "property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdym9WF0E9YgRMBWDOd-dwzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_0832e3734e53450e2a79800e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "North Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "713 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-97fa-7359-85f2-c038612182c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fa-97fa-7359-85f2-c038612182c0",
        "storage_key": "property/6767906449167726/01a024fa-97fa-7359-85f2-c038612182c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/North-Ave.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6649073214810790357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-ave",
      "poi_latitude": "33.77179",
      "poi_longitude": "-84.38709",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-ab99-77b2-a0d6-8cedadbd82fc",
        "storage_key": "property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJu65s0W4E9YgR1ZlcTtxARlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_3fada8ed44ded69d3a1217e5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Civic Center Marta Station (Northbound)",
      "poi_type": "Transportation & Transit",
      "poi_address": "435 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-03db-74ba-bd39-9ebbfa6afbc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fd-03db-74ba-bd39-9ebbfa6afbc4",
        "storage_key": "property/6767906449167726/01a024fd-03db-74ba-bd39-9ebbfa6afbc4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cobbcounty.org/index.php?option=com_content&view=category&layout=blog&id=426&Itemid=2071",
      "poi_directions_map_url": "https://maps.google.com/?cid=14796171962493795015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "civic-center-marta-station-northbound",
      "poi_latitude": "33.7667382",
      "poi_longitude": "-84.38737359999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-ab99-77b2-a0d6-8cedadbd82fc",
        "storage_key": "property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9cNVQ3oE9YgRx3oJpAGQVs0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_315f5264143dd5366bc82643",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Peachtree Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "216 Peachtree Rd NE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-fe63-71b9-85e5-305220aafd76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-fe63-71b9-85e5-305220aafd76",
        "storage_key": "property/6767906449167726/01a024fc-fe63-71b9-85e5-305220aafd76.webp",
        "width": 1280,
        "height": 862
      },
      "poi_business_url": "https://itsmarta.com/Peachtree-Center.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=968778342906516042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peachtree-center",
      "poi_latitude": "33.7580702",
      "poi_longitude": "-84.38739059999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-ab99-77b2-a0d6-8cedadbd82fc",
        "storage_key": "property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3RLXaHgE9YgRStIII8XKcQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_b8d9ffa9bd039fbb5804ab69",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Five Points MARTA Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 Alabama St SW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-fff3-752d-9782-2c18ea059ef2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-fff3-752d-9782-2c18ea059ef2",
        "storage_key": "property/6767906449167726/01a024fc-fff3-752d-9782-2c18ea059ef2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9456548135659215659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-points-marta-station",
      "poi_latitude": "33.7539909",
      "poi_longitude": "-84.391697",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV048YwAJ9YgRK5tZK21oPIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_4df5cf44ff7080b9d3b21824",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Lindbergh Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2424 Piedmont Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-9724-72a7-97ce-a9e366633441.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fa-9724-72a7-97ce-a9e366633441",
        "storage_key": "property/6767906449167726/01a024fa-9724-72a7-97ce-a9e366633441.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Lindbergh.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=632507744447004235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lindbergh-center",
      "poi_latitude": "33.8231157",
      "poi_longitude": "-84.36943869999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-ab99-77b2-a0d6-8cedadbd82fc",
        "storage_key": "property/6767906449167726/01a024fa-ab99-77b2-a0d6-8cedadbd82fc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJo8oZEMIF9YgRS35yQXEexwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_a85e57694aef8e6f52d73451",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Amtrak",
      "poi_type": "Transportation & Transit",
      "poi_address": "1688 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-ff4f-76ee-8db0-30d2d99a828c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-ff4f-76ee-8db0-30d2d99a828c",
        "storage_key": "property/6767906449167726/01a024fc-ff4f-76ee-8db0-30d2d99a828c.webp",
        "width": 679,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/stations/atl",
      "poi_directions_map_url": "https://maps.google.com/?cid=11594273034950126537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak",
      "poi_latitude": "33.7993975",
      "poi_longitude": "-84.3926057",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 866-332-0334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4Hqac4F9YgRyasXbeUh56A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_2861e5446864ad8a13d7ca53",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fc-ffaa-77e7-97e9-13ce5ccf8431.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fc-ffaa-77e7-97e9-13ce5ccf8431",
        "storage_key": "property/6767906449167726/01a024fc-ffaa-77e7-97e9-13ce5ccf8431.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 18 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-13df-76ef-a1f5-ebbedff440ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fd-13df-76ef-a1f5-ebbedff440ba",
        "storage_key": "property/6767906449167726/01a024fd-13df-76ef-a1f5-ebbedff440ba.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_60d5e593abea908ebcde0df8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Atlantic Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "1380 Atlantic Dr NW, Atlanta, GA 30363, USA",
      "poi_short_description": "Upmarket retail complex with department & specialty stores, a multiplex & a range of dining options.",
      "poi_long_description": "Upmarket retail complex with department & specialty stores, a multiplex & a range of dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-045d-75ee-8a10-c503b1ddf8f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fd-045d-75ee-8a10-c503b1ddf8f1",
        "storage_key": "property/6767906449167726/01a024fd-045d-75ee-8a10-c503b1ddf8f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atlanticstation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16075264230802959861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlantic-station",
      "poi_latitude": "33.79249830000001",
      "poi_longitude": "-84.39651820000002",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-410-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a857-7330-a390-9cb602b7e6b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a857-7330-a390-9cb602b7e6b0",
        "storage_key": "property/6767906449167726/01a024fa-a857-7330-a390-9cb602b7e6b0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk8PKSvYE9YgR9a2Nw6XPFt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_9f6bd7c8f2780d80591e1349",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Federal Reserve Bank of Atlanta",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-00be-758e-ab92-d1f4e2ca4b06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fd-00be-758e-ab92-d1f4e2ca4b06",
        "storage_key": "property/6767906449167726/01a024fd-00be-758e-ab92-d1f4e2ca4b06.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.atlantafed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10811497039753145462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-reserve-bank-of-atlanta",
      "poi_latitude": "33.782425",
      "poi_longitude": "-84.3847892",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-498-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-13ec-70bf-9bf1-ed0cd3cd87be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fd-13ec-70bf-9bf1-ed0cd3cd87be",
        "storage_key": "property/6767906449167726/01a024fd-13ec-70bf-9bf1-ed0cd3cd87be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC_yk6kIE9YgRdmysoEYnCpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "ec_20fd55a6236f8f76e9aa4274",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Equifax",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1550 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-0a7c-763b-90f5-7c9212519f3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fd-0a7c-763b-90f5-7c9212519f3c",
        "storage_key": "property/6767906449167726/01a024fd-0a7c-763b-90f5-7c9212519f3c.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.equifax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11966891513933177530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "equifax",
      "poi_latitude": "33.7965403",
      "poi_longitude": "-84.3885395",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 888-202-4025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGTMTg1EE9YgRuqKfuW3wEqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_59fdcca6fd343fa1473b184c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Southern Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "30 Ivan Allen Jr Blvd NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-0953-71cf-81ad-1f2ca109b006.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fd-0953-71cf-81ad-1f2ca109b006",
        "storage_key": "property/6767906449167726/01a024fd-0953-71cf-81ad-1f2ca109b006.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.southerncompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7744093688251453066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-company",
      "poi_latitude": "33.76432",
      "poi_longitude": "-84.38825899999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-506-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4FWLHoE9YgRio6S8y2MeGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_90ab1c07ad43841e2e06e837",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "The Center Atlanta Food Court",
      "poi_type": "Restaurants",
      "poi_address": "190 Marietta St NW, Atlanta, GA 30303, USA",
      "poi_short_description": "Busy and spacious dining area in the CNN Center serving fast-food classics like burgers, chicken and sandwiches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-0661-777a-ad1f-08369e57290c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fd-0661-777a-ad1f-08369e57290c",
        "storage_key": "property/6767906449167726/01a024fd-0661-777a-ad1f-08369e57290c.webp",
        "width": 1280,
        "height": 972
      },
      "poi_business_url": "http://thecenteratlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8635100578827649518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-center-atlanta-food-court",
      "poi_latitude": "33.7577867",
      "poi_longitude": "-84.3947819",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-850-7238",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a875-70e2-838c-87d905112e41",
        "storage_key": "property/6767906449167726/01a024fa-a875-70e2-838c-87d905112e41.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3095cIAD9YgR7sHKyDkK1nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_727d12cc806d6c5ef1ade62e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Emory University",
      "poi_type": "Education",
      "poi_address": "201 Dowman Dr, Atlanta, GA 30322, USA",
      "poi_short_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_long_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-72e6-7139-a201-8c884ccc65af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fa-72e6-7139-a201-8c884ccc65af",
        "storage_key": "property/6767906449167726/01a024fa-72e6-7139-a201-8c884ccc65af.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.emory.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401157007639682133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university",
      "poi_latitude": "33.7973735",
      "poi_longitude": "-84.3252791",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 404-727-6123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a86b-77f6-9bde-bfec640c4742",
        "storage_key": "property/6767906449167726/01a024fa-a86b-77f6-9bde-bfec640c4742.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHU-KgPcG9YgRVZzdN2J61Vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_d28ca9e6b435ffdfb59beb6a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Arthur M. Blank Hospital - Children's Healthcare of Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "2220 N Druid Hills Rd NE, Atlanta, GA 30329, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fd-0a9b-704e-a173-e0df16915127.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a024fd-0a9b-704e-a173-e0df16915127",
        "storage_key": "property/6767906449167726/01a024fd-0a9b-704e-a173-e0df16915127.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.choa.org/locations/arthur-m-blank-hospital?cid=na1_ch-Yx_na3_na4_d-yxll_na6",
      "poi_directions_map_url": "https://maps.google.com/?cid=5788257586282724250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arthur-m-blank-hospital---childrens-healthcare-of-atlanta",
      "poi_latitude": "33.8308023",
      "poi_longitude": "-84.3308112",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-785-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a8ca-7367-8ecb-a3dbb3653e2e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a8ca-7367-8ecb-a3dbb3653e2e",
        "storage_key": "property/6767906449167726/01a024fa-a8ca-7367-8ecb-a3dbb3653e2e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30fQb-oH9YgRmnvXcpsFVFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_475e0be8dbe98d42d2070477",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "poi_name": "Blue Cross Blue Shield of Georgia",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3350 Peachtree Rd, Atlanta, GA 30326, USA",
      "poi_short_description": "Health insurance agency located inside 3350 Peachtree.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bcbsga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4449571878928727238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-cross-blue-shield-of-georgia",
      "poi_latitude": "33.847733",
      "poi_longitude": "-84.3682109",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-842-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a024fa-a865-769f-adcb-f6a6cc779384",
        "storage_key": "property/6767906449167726/01a024fa-a865-769f-adcb-f6a6cc779384.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWwhePYF9YgRxjwdjgwOwD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f1682531d27e2f5aee388275",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6d73d09227766c77aea51e81",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_44f0878afd00620101d57884",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1abed9c6ba448bf02f96101a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fcbf041dd513f1ef65682abe",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_22b1efe3929d123d2994dbea",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_6886043c83d08a4131df08f7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "rating": "5",
      "name": "Zhaoyang Du",
      "text": "I’ve been living at Hanover Midtown for a while now, and overall I really enjoy it. The location is super convenient, especially if you work or spend time around Midtown Atlanta. Everything you need—restaurants, grocery stores, and gyms—is just a short walk away.\nThe apartment itself is very comfortable and well-maintained. The layout is modern, the appliances are nice, and the overall environment feels clean and quiet, which makes it easy to relax after a long day. I also feel safe living here, which is really important to me.\nThe amenities are another big plus. The gym and common areas are well designed and actually useful, not just for show. Management and staff have been responsive and helpful whenever I’ve needed assistance.\nOverall, it’s been a great living experience, and I would definitely recommend Hanover Midtown to anyone looking for a comfortable and convenient place to live in Atlanta.",
      "date": "2026-03-23",
      "title": "false"
    },
    {
      "id": "ec_6dc86d112eda9a89df4a149e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "rating": "5",
      "name": "Kierra Ward",
      "text": "⭐⭐⭐⭐⭐\n\nI’ve been apartment hunting for a one-bedroom in the Buckhead and Midtown Atlanta area, and after touring several communities, Hanover Midtown has officially taken my #1 spot.\n\nFrom the moment I walked in, I was impressed. The property was exceptionally clean, smelled amazing, and had such a peaceful atmosphere—even though it’s right in the heart of the city.\n\nI also want to give a special shout-out to the team. The property manager, John, came over to personally introduce himself, welcomed me, and even offered me a sparkling water, which was a thoughtful touch.\n\nRaheem gave me my tour, and he was outstanding. He was incredibly knowledgeable about the property and took the time to highlight the features that mattered most to me, both in the community and in the apartment itself. As a dog parent, I loved seeing the on-site dog park, plus the additional park directly across the street.\n\nWhat impressed me the most was how Raheem interacted with the residents. Throughout the tour, every resident we passed, he greeted by name. That speaks volumes about the relationships the staff has built with the community and made the property feel genuinely welcoming.\n\nIf you’re looking for an apartment in Buckhead or Midtown, I highly recommend adding Hanover Midtown to your list. So far, it’s been the best community I’ve toured, and it has definitely set the standard for the rest of my apartment search.",
      "date": "2026-06-30",
      "title": "false"
    },
    {
      "id": "ec_17f2831c3ccf936a5efc6325",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "rating": "5",
      "name": "Kunal Bhatiya",
      "text": "From the moment we walked into Hanover Midtown, we were impressed. The community is beautiful, and the amenities truly stand out—they're modern, well-maintained, and offer everything you could want in a place to call home. The highlight of our visit was meeting Rahim. He provided an exceptional tour, answered all of our questions with confidence, and took the time to understand exactly what we were looking for. His warm personality, positive energy, and genuine relationships with the residents made a lasting impression. It's clear that he takes pride in what he does. Between the amazing location, the stunning property, and the outstanding service, we left feeling excited and can't wait to lease here soon!",
      "date": "2026-07-01",
      "title": "false"
    },
    {
      "id": "ec_4467bc226bad8084e9b6dbe3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "rating": "5",
      "name": "Paula Hawkins",
      "text": "Jon at Hanover Midtown made my apartment search an amazing experience. He was professional, knowledgeable, and incredibly helpful throughout the entire process. He took so much stress off of me and made everything easy from start to finish. If you’re looking for exceptional customer service, I highly recommend working with Jon. Thank you for making my move back to Atlanta such a great experience!",
      "date": "2026-06-30",
      "title": "false"
    },
    {
      "id": "ec_0f0b3a37008bb48c885dd2a4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "rating": "5",
      "name": "William Burnett",
      "text": "Jon gave me an amazing tour of the upscale residential complex, highlighting its modern architectural design and spacious interiors. Although I haven't made a decision yet, I was blown away by the building's efficient layout and open-concept living areas, and the pool, with its amazing views and spacious lounge area, was absolutely stunning. I especially loved the gym's impressive range of high-tech equipment, including cardio machines, free weights, and dedicated yoga zones.",
      "date": "2026-06-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_a70b576510caffa7cd17a1e4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167726/01a024fa-9c3b-7308-a596-1320fa2f1396.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a024fa-9c3b-7308-a596-1320fa2f1396",
        "storage_key": "property/6767906449167726/01a024fa-9c3b-7308-a596-1320fa2f1396.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 BR, 1 BA - 794 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?model=HRgFCmAQF9t"
    }
  ],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-midtown-atlanta-roxanne",
      "search_query": "pet friendly apartments midtown atlanta",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Midtown Atlanta",
      "h2_subtitle": "Discover pet friendly apartments in Midtown Atlanta. The Roxanne offers a welcoming environment for you and your furry friends.",
      "page_copy": "Looking for pet friendly apartments in Midtown Atlanta? The Roxanne is the perfect place for both you and your furry companions. Offering spacious living arrangements and modern kitchens with imported cabinetry, these apartments are designed with comfort in mind. Nestled in the vibrant Midtown Atlanta neighborhood, The Roxanne ensures a blend of city life excitement and a welcoming community feel.\n\nAt The Roxanne, you’ll find pet-friendly amenities that simplify your life. Enjoy a leisurely stroll through Midtown’s pet-friendly parks and let your furry friend bask in the southern sun. This community also features bicycle storage, a concierge to assist with your needs, and high-speed Wi-Fi in all common spaces. Make The Roxanne your new pet-friendly home in Midtown Atlanta.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Midtown Atlanta",
      "seo_description": "Explore pet friendly living at The Roxanne in Midtown Atlanta. Ideal for pet owners seeking comfort and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-fulton-county-roxanne",
      "search_query": "luxury apartments with pool in fulton county",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Fulton County",
      "h2_subtitle": "Experience luxury living with a pool in Fulton County. The Roxanne offers upscale amenities in a prime location.",
      "page_copy": "If you're seeking luxury apartments with a pool in Fulton County, look no further than The Roxanne. Situated in the heart of Midtown Atlanta, our community offers an unparalleled living experience. The elegant design of our modern kitchens features imported cabinetry, contributing to the luxurious atmosphere that residents love.\n\nBeyond the exquisite units, The Roxanne provides exceptional community amenities. Take advantage of our community gas grill/BBQ area, perfect for gatherings after enjoying a swim in the pool. Residents also benefit from a concierge and high-speed Wi-Fi in all common areas, ensuring that both relaxation and productivity are at your fingertips. Experience refined living at The Roxanne in Fulton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Fulton County",
      "seo_description": "Discover luxury living with a pool at The Roxanne in Fulton County. Enjoy upscale amenities in a prime Midtown Atlanta location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-atlanta-ga-roxanne",
      "search_query": "apartments with in unit laundry atlanta ga",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Atlanta, GA",
      "h2_subtitle": "Find apartments with in-unit laundry in Atlanta, GA. The Roxanne offers modern living in the heart of the city.",
      "page_copy": "The Roxanne presents the perfect option for anyone seeking apartments with in-unit laundry in Atlanta, GA. Situated in bustling Midtown Atlanta, our community is designed to cater to all your urban living needs. With modern kitchens featuring imported cabinetry and spacious layouts, The Roxanne ensures every convenience is right at your fingertips.\n\nOur community redefines city living, offering a host of amenities such as bicycle storage and a convenient concierge service. Socialize at the community gas grill/BBQ area or stay connected with high-speed Wi-Fi available in all common spaces. Explore unparalleled comfort and style at The Roxanne, where in-unit laundry and other premium features make life beautifully efficient.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Atlanta, GA",
      "seo_description": "Discover The Roxanne's in-unit laundry apartments in Atlanta, GA. Enjoy modern conveniences and a prime Midtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "apartment-covered-parking-30309-roxanne",
      "search_query": "apartment with covered parking in 30309",
      "category": "Amenity",
      "h1_title": "Apartment with Covered Parking in 30309",
      "h2_subtitle": "Explore apartments with covered parking in the heart of 30309. The Roxanne offers premium living spaces in Midtown Atlanta.",
      "page_copy": "Searching for an apartment with covered parking in the 30309 area? The Roxanne in Midtown Atlanta not only provides covered parking but also encapsulates modern urban living. Residents can enjoy beautifully designed living spaces featuring modern kitchens with imported cabinetry, ideal for those who appreciate style and functionality.\n\nThe Roxanne offers an array of amenities that elevate everyday living. Alongside covered parking, indulge in community features such as a gas grill/BBQ area, bicycle storage, and high-speed Wi-Fi in common areas. With a dedicated concierge on hand, your day-to-day needs in this Fulton County gem are effortlessly met. Experience a blend of convenience and luxury at The Roxanne.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Covered Parking in 30309",
      "seo_description": "Discover The Roxanne's apartments with covered parking in 30309. Enjoy modern amenities in the vibrant Midtown Atlanta community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "high-rise-apartments-city-views-atlanta-roxanne",
      "search_query": "high rise apartments in atlanta with city views",
      "category": "Amenity",
      "h1_title": "High Rise Apartments in Atlanta with City Views",
      "h2_subtitle": "Discover high rise apartments with stunning city views in Atlanta. The Roxanne offers luxurious living in Midtown.",
      "page_copy": "For those in search of high rise apartments in Atlanta with mesmerizing city views, The Roxanne is an exceptional choice. Nestled in the vibrant community of Midtown Atlanta, our high-rise residences offer sweeping panoramas of the city's skyline, providing a daily dose of inspiration and awe-inspiring views.\n\nThe Roxanne not only boasts impressive views but also features outstanding in-unit and community amenities. Enjoy modern kitchens with elegant imported cabinetry while the community amenities include a concierge and a BBQ area perfect for social gatherings. Residents also appreciate bicycle storage and high-speed Wi-Fi in all common spaces. Experience the pinnacle of luxury with unparalleled views at The Roxanne.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High Rise Apartments in Atlanta with City Views",
      "seo_description": "Explore The Roxanne's high rise apartments with city views in Atlanta. Experience luxury living in Midtown with stunning skyline panoramas.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "studio-apartments-near-midtown-atlanta-roxanne",
      "search_query": "studio apartments near Midtown Atlanta",
      "category": "Floorplan",
      "h1_title": "Studio Apartments Near Midtown Atlanta",
      "h2_subtitle": "Find studio apartments near Midtown Atlanta at The Roxanne. Experience modern comfort and convenience.",
      "page_copy": "If you're seeking studio apartments near Midtown Atlanta, The Roxanne offers the ideal location paired with contemporary living. Perfectly situated in this vibrant neighborhood, our studio apartments combine functionality with style, featuring modern kitchens fitted with imported cabinetry.\n\nResidents of The Roxanne enjoy a variety of top-notch amenities, including bicycle storage and high-speed Wi-Fi in all common areas. The community gas grill/BBQ area and our attentive concierge add to the appeal, ensuring a comfortable lifestyle. Discover how our studio apartments provide the perfect blend of location, amenities, and design at The Roxanne.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Near Midtown Atlanta",
      "seo_description": "Discover studio apartments near Midtown Atlanta at The Roxanne. Enjoy modern amenities and a prime location in this vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-atlanta-ga-roxanne",
      "search_query": "1 bedroom apartments in Atlanta GA",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Atlanta, GA",
      "h2_subtitle": "Discover 1 bedroom apartments in Atlanta, GA at The Roxanne. Enjoy the best of Midtown living with unmatched amenities.",
      "page_copy": "The Roxanne offers exquisite 1 bedroom apartments in Atlanta, GA, located in the bustling Midtown district. These well-designed spaces are perfect for those who desire a blend of comfort and style, highlighted by modern kitchens featuring imported cabinetry.\n\nLiving at The Roxanne means access to a host of amenities crafted for convenience. Residents savour high-speed Wi-Fi seamlessly available in all common areas, utilize bike storage, and enjoy social gatherings at the community gas grill/BBQ area. With our dedicated concierge service, experience unparalleled luxury and convenience in one of Atlanta's most coveted neighborhoods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Atlanta, GA",
      "seo_description": "Explore 1 bedroom apartments in Atlanta, GA at The Roxanne. Enjoy modern living with superb amenities in the heart of Midtown.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-midtown-atlanta-roxanne",
      "search_query": "2 bedroom apartments Midtown Atlanta",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Midtown Atlanta",
      "h2_subtitle": "Explore spacious 2 bedroom apartments in Midtown Atlanta at The Roxanne. Experience luxurious living with top-tier amenities.",
      "page_copy": "The Roxanne proudly offers 2 bedroom apartments in Midtown Atlanta, designed to cater to those seeking ample living space combined with upscale city living. Our residences provide the perfect setting to enjoy Midtown’s vibrant lifestyle, equipped with modern kitchens that feature imported cabinetry.\n\nBeyond the expansive living spaces, residents at The Roxanne benefit from exceptional amenities including bicycle storage, a distinguished concierge service, and high-speed Wi-Fi in all shared areas. Our community gas grill/BBQ area further complements your elegant living experience, making The Roxanne a leading choice for those desiring a refined urban lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Midtown Atlanta",
      "seo_description": "Discover spacious 2 bedroom apartments in Midtown Atlanta at The Roxanne. Luxury amenities in a vibrant community await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-fulton-county-ga-roxanne",
      "search_query": "3 bedroom apartments in Fulton County GA",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Fulton County, GA",
      "h2_subtitle": "Discover luxurious 3 bedroom apartments in Fulton County, GA at The Roxanne. Enjoy spacious living and premium amenities.",
      "page_copy": "The Roxanne presents an exceptional selection of 3 bedroom apartments in Fulton County, GA, offering residents both space and sophistication in the heart of the city. Our well-appointed residences are perfect for families or those in need of extra room, showcasing modern kitchens with imported cabinetry that seamlessly blend functionality with style.\n\nLiving at The Roxanne means access to an array of premium amenities, including convenient bicycle storage, dedicated concierge services, and high-speed Wi-Fi across all communal areas. Residents also enjoy a community gas grill/BBQ area, perfect for entertaining guests or enjoying a quiet evening at home. Experience the best of apartment living at The Roxanne.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Fulton County, GA",
      "seo_description": "Explore 3 bedroom apartments in Fulton County, GA at The Roxanne. Spacious living with premium amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "apartments-near-georgia-tech-midtown-atlanta-roxanne",
      "search_query": "apartments near Georgia Tech Midtown Atlanta",
      "category": "School",
      "h1_title": "Apartments Near Georgia Tech in Midtown Atlanta",
      "h2_subtitle": "Find ideal apartments near Georgia Tech in Midtown Atlanta at The Roxanne. Enjoy convenient access and premium amenities.",
      "page_copy": "The Roxanne is a premier choice for those seeking apartments near Georgia Tech in Midtown Atlanta. Perfectly located, our community offers residents a seamless commute to the bustling campus, while providing a peaceful retreat from academic life. Enjoy modern kitchens with imported cabinetry that add a touch of elegance to your daily routine.\n\nOur residents benefit from a wealth of community amenities designed to enhance city living. Take advantage of high-speed Wi-Fi throughout all common areas, flexible bicycle storage options, and a fully-equipped concierge service. Socialize and unwind at our community gas grill/BBQ area, fostering a sense of community in the heart of the vibrant Midtown district.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia Tech Midtown Atlanta",
      "seo_description": "The Roxanne offers premium apartments near Georgia Tech in Midtown Atlanta. Enjoy modern living with excellent amenities and location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "emory-university-apartments-fulton-county-roxanne",
      "search_query": "Emory University apartments in Fulton County",
      "category": "School",
      "h1_title": "Emory University Apartments in Fulton County",
      "h2_subtitle": "Discover apartments near Emory University in Fulton County, offering modern amenities and convenient living at The Roxanne.",
      "page_copy": "The Roxanne offers exceptional Emory University apartments in Fulton County for those seeking proximity combined with luxury. Our stylish residences provide an ideal home base for both students and faculty, with easy access to the vibrant campus and surrounding areas.\n\nEnjoy spacious floor plans featuring modern kitchens with imported cabinetry, designed to meet diverse lifestyle needs. Residents can take advantage of our excellent amenities, including bicycle storage, a dedicated concierge, and high-speed Wi-Fi in all communal areas. Our community gas grill/BBQ area promises a welcoming environment for relaxation and fostering connections in Fulton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Emory University Apartments in Fulton County",
      "seo_description": "Explore The Roxanne's apartments near Emory University in Fulton County. Enjoy modern living and convenient amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "georgia-state-university-nearby-apartments-atlanta-roxanne",
      "search_query": "Georgia State University nearby apartments in Atlanta",
      "category": "School",
      "h1_title": "GSU Nearby Apartments in Atlanta",
      "h2_subtitle": "Find Georgia State University nearby apartments in Atlanta at The Roxanne. Enjoy unbeatable convenience and modern living.",
      "page_copy": "Discover ultimate convenience at The Roxanne, offering Georgia State University nearby apartments in Atlanta. Located in the bustling Midtown area, our community provides easy access to GSU, perfect for students, faculty, and staff looking for a short commute and vibrant city living.\n\nResidents at The Roxanne enjoy modern kitchens with imported cabinetry, enhancing everyday living with style and efficiency. Our top-tier amenities include a concierge service, high-speed Wi-Fi throughout communal spaces, and a dedicated bicycle storage facility. Unwind at the community gas grill/BBQ area, fostering a connected and engaging community atmosphere in the heart of Atlanta.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "GSU Nearby Apartments in Atlanta",
      "seo_description": "The Roxanne offers Georgia State University nearby apartments in Atlanta. Experience the perfect blend of convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "apartments-close-to-t-deck-atlanta-roxanne",
      "search_query": "apartments close to T Deck Atlanta",
      "category": "School",
      "h1_title": "Apartments Close to T Deck Atlanta",
      "h2_subtitle": "Explore The Roxanne, offering apartments close to T Deck Atlanta. Enjoy convenient access and premium amenities just steps away.",
      "page_copy": "If you're searching for apartments close to T Deck in Atlanta, look no further than The Roxanne. Perfectly positioned in Midtown, our community ensures easy access to this major parking and transportation hub, making commutes and visits a breeze. \n\nOur residents enjoy a range of premium amenities designed to complement city living. With modern kitchens showcasing imported cabinetry, our apartments provide both functionality and elegance. Benefit from our community features like high-speed Wi-Fi in all common areas, bicycle storage, and a concierge service. Plus, the community gas grill/BBQ area offers a gathering space to socialize and relax in the heart of Atlanta.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to T Deck Atlanta",
      "seo_description": "Discover The Roxanne's apartments close to T Deck Atlanta. Enjoy easy access and modern amenities in a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "scad-atlanta-apartments-30309-roxanne",
      "search_query": "SCAD Atlanta apartments in 30309",
      "category": "School",
      "h1_title": "SCAD Atlanta Apartments in 30309",
      "h2_subtitle": "Experience premier living with SCAD Atlanta apartments in 30309 at The Roxanne. Modern amenities meet artistic inspiration.",
      "page_copy": "The Roxanne is the ideal choice for those seeking SCAD Atlanta apartments in 30309. Nestled in the vibrant Midtown district, our luxurious community offers easy access to SCAD Atlanta, catering to students and faculty alike with an artistic flair and creative energy.\n\nOur residents enjoy beautifully designed apartments featuring modern kitchens with imported cabinetry that blend style with functionality. Beyond the interiors, The Roxanne provides high-speed Wi-Fi throughout all common areas, a concierge service, and secure bicycle storage. Enjoy the communal gas grill/BBQ area as a perfect spot to relax and connect with fellow art enthusiasts in the heart of Atlanta.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "SCAD Atlanta Apartments in 30309",
      "seo_description": "Live at The Roxanne, offering SCAD Atlanta apartments in 30309. Enjoy modern amenities and a vibrant community near SCAD.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "apartments-near-grady-memorial-hospital-midtown-atlanta-roxanne",
      "search_query": "apartments near Grady Memorial Hospital Midtown Atlanta",
      "category": "Hospital",
      "h1_title": "Apartments Near Grady Memorial Hospital",
      "h2_subtitle": "Discover convenient living at The Roxanne, offering apartments near Grady Memorial Hospital in Midtown Atlanta with top-notch amenities.",
      "page_copy": "For those seeking apartments near Grady Memorial Hospital in Midtown Atlanta, The Roxanne presents an ideal living option. Our location in the heart of Midtown ensures that healthcare professionals and hospital staff enjoy both proximity and comfort.\n\nInside The Roxanne, residents are treated to high-end features such as modern kitchens with imported cabinetry. Our community amenities include high-speed Wi-Fi throughout all common areas, a concierge service, and convenient bicycle storage. The community gas grill/BBQ area offers a relaxed environment for unwinding after a busy day. Join a community that values both accessibility and quality at The Roxanne.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Grady Memorial Hospital",
      "seo_description": "The Roxanne offers stylish apartments near Grady Memorial Hospital in Midtown Atlanta. Enjoy convenience and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "apartments-close-to-emory-university-hospital-midtown-fulton-county-roxanne",
      "search_query": "apartments close to Emory University Hospital Midtown Fulton County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Emory University Hospital",
      "h2_subtitle": "Live near Emory University Hospital Midtown in Fulton County at The Roxanne, where comfort meets convenience.",
      "page_copy": "If you're looking for apartments close to Emory University Hospital Midtown in Fulton County, The Roxanne provides a blend of convenience and style. Situated in the heart of Midtown Atlanta, our community offers easy access for healthcare workers and students.\n\nAt The Roxanne, residents enjoy meticulously designed spaces featuring modern kitchens with imported cabinetry. The on-site amenities include high-speed Wi-Fi in all common areas, a concierge service, and secure bicycle storage. The community gas grill/BBQ area provides a perfect setting for relaxation and socializing. Experience the vibrant atmosphere and unmatched convenience at The Roxanne.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Emory University Hospital",
      "seo_description": "Discover The Roxanne's apartments close to Emory University Hospital Midtown in Fulton County, featuring modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "apartments-near-atlanta-botanical-garden-midtown-roxanne",
      "search_query": "apartments near atlanta botanical garden midtown",
      "category": "Park",
      "h1_title": "Apartments Near Atlanta Botanical Garden",
      "h2_subtitle": "Experience nature and luxury at The Roxanne, offering apartments near the Atlanta Botanical Garden in Midtown.",
      "page_copy": "For those seeking apartments near the Atlanta Botanical Garden in Midtown, The Roxanne offers the perfect blend of urban living and natural beauty. Situated just a short distance from the lush landscapes of the garden, our community invites you to enjoy the best of both worlds.\n\nThe Roxanne boasts modern living spaces with top-tier amenities, including stylish kitchens with imported cabinetry. Enjoy high-speed Wi-Fi in common areas, a concierge service to assist with your needs, and safe bicycle storage. Our community also features a gas grill/BBQ area, perfect for entertaining or relaxing after a day exploring the garden. Embrace a lifestyle that balances convenience and nature at The Roxanne.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Atlanta Botanical Garden",
      "seo_description": "Live at The Roxanne, offering apartments near the Atlanta Botanical Garden in Midtown. Enjoy proximity to nature with luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "midtown-apartments-by-piedmont-park-roxanne",
      "search_query": "midtown apartments by piedmont park",
      "category": "Park",
      "h1_title": "Midtown Apartments by Piedmont Park",
      "h2_subtitle": "Enjoy life at The Roxanne, located by Piedmont Park in Midtown Atlanta, offering unparalleled access to city living and green spaces.",
      "page_copy": "Experience the vibrant Midtown lifestyle with The Roxanne, offering apartments by Piedmont Park. Our prime location provides residents with easy access to one of Atlanta's most beloved outdoor spaces, perfect for recreation and relaxation.\n\nThe Roxanne is synonymous with modern living, featuring chic kitchens with imported cabinetry and community perks like high-speed Wi-Fi in all common areas. Enjoy the convenience of our concierge service and bicycle storage, as well as a community gas grill/BBQ area ideal for social gatherings. Embrace the urban lifestyle and serene parkland views, all from your new home at The Roxanne.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Apartments by Piedmont Park",
      "seo_description": "Discover The Roxanne's Midtown apartments by Piedmont Park, combining city convenience and luxury with nearby green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "midtown-atlanta-apartments-near-centennial-olympic-park-roxanne",
      "search_query": "midtown atlanta apartments near centennial olympic park",
      "category": "Park",
      "h1_title": "Midtown Atlanta Apartments Near Centennial Park",
      "h2_subtitle": "Discover The Roxanne, offering exceptional Midtown Atlanta apartments near Centennial Olympic Park, where convenience meets vibrant city life.",
      "page_copy": "Located in the heart of Midtown Atlanta, The Roxanne presents apartments near Centennial Olympic Park. This central location provides residents with unparalleled access to exciting city attractions, restaurants, and cultural venues.\n\nOur apartments feature modern kitchens with imported cabinetry, designed to match your lifestyle. At The Roxanne, enjoy amenities such as high-speed Wi-Fi in all common areas, a concierge service, and secure bicycle storage. Whether you're hosting a barbecue in the community gas grill area or exploring nearby landmarks, you’ll relish the blend of sophistication and convenience. Make The Roxanne your urban haven close to everything Atlanta has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Atlanta Apartments Near Centennial Park",
      "seo_description": "Live at The Roxanne, offering Midtown Atlanta apartments near Centennial Olympic Park with upscale amenities and urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "apartments-close-to-westside-park-fulton-county-roxanne",
      "search_query": "apartments close to westside park fulton county",
      "category": "Park",
      "h1_title": "Apartments Close to Westside Park",
      "h2_subtitle": "Discover The Roxanne, offering stylish apartments close to Westside Park in Fulton County, perfectly balancing nature and urban living.",
      "page_copy": "The Roxanne provides residents with exceptional living in modern apartments close to Westside Park in Fulton County. Enjoy the convenience of nearby green spaces and the vibrant surroundings of Midtown Atlanta.\n\nOur community is designed to offer a contemporary lifestyle, with amenities such as imported cabinetry in modern kitchens, high-speed Wi-Fi in common areas, and a responsive concierge service. With dedicated bicycle storage and a community gas grill/BBQ area, The Roxanne balances comfortable living with recreational opportunities. Experience a location that offers access to urban excitement and natural beauty, all from your home at The Roxanne.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Westside Park, Fulton County",
      "seo_description": "Explore The Roxanne's apartments close to Westside Park in Fulton County, blending urban and natural convenience with luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "apartments-near-five-points-atlanta-ga-roxanne",
      "search_query": "apartments near Five Points Atlanta GA",
      "category": "Transit",
      "h1_title": "Apartments Near Five Points Atlanta GA",
      "h2_subtitle": "Live in style at The Roxanne, offering premier apartments near Five Points, Atlanta, GA, surrounded by vibrant city life and key attractions.",
      "page_copy": "Situated in Atlanta's bustling heart, The Roxanne offers stunning apartments near Five Points, providing you with easy access to the city's core. Enjoy the vibrant atmosphere of Downtown Atlanta while residing in the comfortable and modern living spaces of The Roxanne.\n\nOur property features luxury amenities such as sophisticated kitchens with imported cabinetry and high-speed Wi-Fi throughout all common areas. Residents benefit from a full concierge service, bicycle storage, and a community gas grill/BBQ area perfect for socializing. Choose The Roxanne and immerse yourself in the dynamic culture and lifestyle of Atlanta, all while enjoying the comforts of home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Five Points, Atlanta GA",
      "seo_description": "The Roxanne offers modern apartments near Five Points in Atlanta, GA. Enjoy urban living with premium amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "living-next-to-arts-center-station-midtown-roxanne",
      "search_query": "living next to Arts Center Station Midtown",
      "category": "Transit",
      "h1_title": "Living Next to Arts Center Station",
      "h2_subtitle": "Experience life at The Roxanne, where living next to Arts Center Station in Midtown Atlanta provides unmatched convenience and connectivity.",
      "page_copy": "At The Roxanne, enjoy the advantage of living next to Arts Center Station in Midtown Atlanta. This prime location offers effortless access to MARTA transit, connecting you seamlessly with the entire city.\n\nOur upscale apartments feature modern kitchens with imported cabinetry and amenities such as high-speed Wi-Fi in all public areas and a concierge service. Engage with neighbors at our community gas grill/BBQ area or secure your bike with ease in our designated storage. The Roxanne promises a perfect blend of modern conveniences and easy urban connectivity, right at the heart of Midtown's vibrant arts hub.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Next to Arts Center Station, Midtown",
      "seo_description": "Enjoy living next to Arts Center Station at The Roxanne in Midtown Atlanta, combining premium amenities with top-tier urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "midtown-atlanta-apartments-near-north-ave-station-roxanne",
      "search_query": "Midtown Atlanta apartments near North Ave Station",
      "category": "Transit",
      "h1_title": "Midtown Atlanta Apartments Near North Ave",
      "h2_subtitle": "Discover The Roxanne, offering Midtown Atlanta apartments near North Ave Station, perfectly situated for city commuting and vibrant living.",
      "page_copy": "The Roxanne is your gateway to exceptional urban living with its prime location in Midtown Atlanta, offering modern apartments near North Ave Station. Our location ensures you'll have quick and easy access to MARTA transit, simplifying your daily commute.\n\nEnjoy beautifully designed interiors featuring modern kitchens with imported cabinetry and experience ample communal spaces with high-speed Wi-Fi, ideal for working or socializing. The convenience of our concierge service, designated bicycle storage, and a community gas grill/BBQ area enhances your lifestyle. Choose The Roxanne for a seamless blend of comfort and accessibility in the lively Midtown district.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Atlanta Apartments Near North Ave",
      "seo_description": "Find modern living at The Roxanne, offering Midtown Atlanta apartments near North Ave Station with superb amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "fulton-county-residences-by-lindbergh-center-roxanne",
      "search_query": "Fulton County residences by Lindbergh Center",
      "category": "Transit",
      "h1_title": "Fulton County Residences by Lindbergh",
      "h2_subtitle": "Explore The Roxanne, with residences situated conveniently by Lindbergh Center in Fulton County, offering seamless accessibility and luxury living.",
      "page_copy": "Discover luxury living at The Roxanne, offering premier Fulton County residences by Lindbergh Center. Our location provides the ease of being near MARTA's Lindbergh Center, connecting you efficiently to the heart of Atlanta and beyond.\n\nThe Roxanne is designed for those who appreciate both style and convenience. Enjoy modern kitchens with imported cabinetry, high-speed Wi-Fi in all common spaces, and dedicated bicycle storage. Make use of our concierge services and the community BBQ area, perfect for gatherings. Embrace a lifestyle of comfort and connectivity at The Roxanne, with the city at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fulton County Residences by Lindbergh",
      "seo_description": "The Roxanne offers Fulton County residences by Lindbergh Center, combining luxury living with excellent accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167726",
      "source": "generator",
      "page_item_url": "access-to-midtown-station-from-atlanta-apartments-roxanne",
      "search_query": "access to Midtown Station from Atlanta apartments",
      "category": "Transit",
      "h1_title": "Access Midtown Station Easily from Home",
      "h2_subtitle": "Live at The Roxanne and enjoy unparalleled access to Midtown Station from your Atlanta apartment, perfect for the urban commuter.",
      "page_copy": "The Roxanne provides unparalleled access to Midtown Station from our conveniently located Atlanta apartments. This strategic position allows for effortless commuting throughout the city, making daily travel and exploration a breeze.\n\nOur residencies boast modern kitchens with elegant imported cabinetry, while the community's amenities, such as high-speed Wi-Fi in all common areas, a concierge service, and a BBQ area, elevate your living experience. Whether you're securing your bicycle in our dedicated storage or enjoying a social event at the grill, The Roxanne offers a vibrant lifestyle with exceptional urban connectivity. Discover comfort and convenience every day.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
      "featured_image_media": {
        "alt_text": "Lobby with vertical garden, seating area, reception desk, and elevators.",
        "public_id": "01a024fb-46f1-77db-b99e-91b5bf2fd85b",
        "storage_key": "property/6767906449167726/01a024fb-46f1-77db-b99e-91b5bf2fd85b.webp",
        "width": 1443,
        "height": 623
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Access Midtown Station from Atlanta Apartments",
      "seo_description": "The Roxanne offers Atlanta apartments with direct access to Midtown Station, ideal for commuting with luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InJtMVpHTEFJZ3BlMjc4aTFTVjZ5WWc9PSIsInZhbHVlIjoiZDlkZkowOCt1VGVEQTlEcUFCUy9QUT09IiwibWFjIjoiMTZmZmNhNGQ4M2Y2NWUyZjE2NmQzNzBkN2EwNmQ0OTVmYjVmZDc0ODgxMzJmYmU1YjBjMzQ3OGViNmNmZTdiNCJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6InJtMVpHTEFJZ3BlMjc4aTFTVjZ5WWc9PSIsInZhbHVlIjoiZDlkZkowOCt1VGVEQTlEcUFCUy9QUT09IiwibWFjIjoiMTZmZmNhNGQ4M2Y2NWUyZjE2NmQzNzBkN2EwNmQ0OTVmYjVmZDc0ODgxMzJmYmU1YjBjMzQ3OGViNmNmZTdiNCJ9"
};

export const generatedAt = '2026-08-24T18:45:05.810Z';
